// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3ccircle cx=%278%27 cy=%278%27 r=%273%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 16 16%27%3e%3cpath stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M4 8h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(147 197 253 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(147 197 253 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: rgb(var(--c-gray-200) / 1); /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: "Segoe UI", -apple-system, BlinkMacSystemFont, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: Consolas, Monaco, "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: rgb(var(--c-gray-400) / 1); /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

[type='text'],input:where(:not([type])),[type='email'],[type='url'],[type='password'],[type='number'],[type='date'],[type='datetime-local'],[type='month'],[type='search'],[type='tel'],[type='time'],[type='week'],[multiple],textarea,select {
  appearance: none;
  background-color: #fff;
  border-color: rgb(var(--c-gray-500) / var(--tw-border-opacity, 1));
  border-width: 1px;
  border-radius: 0px;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-shadow: 0 0 #0000;
}

[type='text']:focus, input:where(:not([type])):focus, [type='email']:focus, [type='url']:focus, [type='password']:focus, [type='number']:focus, [type='date']:focus, [type='datetime-local']:focus, [type='month']:focus, [type='search']:focus, [type='tel']:focus, [type='time']:focus, [type='week']:focus, [multiple]:focus, textarea:focus, select:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(var(--c-blue-600) / var(--tw-ring-opacity, 1));
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-color: rgb(var(--c-blue-600) / var(--tw-border-opacity, 1));
}

input::placeholder,textarea::placeholder {
  color: rgb(var(--c-gray-500) / var(--tw-text-opacity, 1));
  opacity: 1;
}

::-webkit-datetime-edit-fields-wrapper {
  padding: 0;
}

::-webkit-date-and-time-value {
  min-height: 1.5em;
  text-align: inherit;
}

::-webkit-datetime-edit {
  display: inline-flex;
}

::-webkit-datetime-edit,::-webkit-datetime-edit-year-field,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-minute-field,::-webkit-datetime-edit-second-field,::-webkit-datetime-edit-millisecond-field,::-webkit-datetime-edit-meridiem-field {
  padding-top: 0;
  padding-bottom: 0;
}

select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  padding-right: 2.5rem;
  print-color-adjust: exact;
}

[multiple],[size]:where(select:not([size="1"])) {
  background-image: initial;
  background-position: initial;
  background-repeat: unset;
  background-size: initial;
  padding-right: 0.75rem;
  print-color-adjust: unset;
}

[type='checkbox'],[type='radio'] {
  appearance: none;
  padding: 0;
  print-color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  -webkit-user-select: none;
          user-select: none;
  flex-shrink: 0;
  height: 1rem;
  width: 1rem;
  color: rgb(var(--c-blue-600) / var(--tw-text-opacity, 1));
  background-color: #fff;
  border-color: rgb(var(--c-gray-500) / var(--tw-border-opacity, 1));
  border-width: 1px;
  --tw-shadow: 0 0 #0000;
}

[type='checkbox'] {
  border-radius: 0px;
}

[type='radio'] {
  border-radius: 100%;
}

[type='checkbox']:focus,[type='radio']:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 2px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(var(--c-blue-600) / var(--tw-ring-opacity, 1));
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}

[type='checkbox']:checked,[type='radio']:checked {
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

[type='checkbox']:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@media (forced-colors: active)  {

  [type='checkbox']:checked {
    appearance: auto;
  }
}

[type='radio']:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@media (forced-colors: active)  {

  [type='radio']:checked {
    appearance: auto;
  }
}

[type='checkbox']:checked:hover,[type='checkbox']:checked:focus,[type='radio']:checked:hover,[type='radio']:checked:focus {
  border-color: transparent;
  background-color: currentColor;
}

[type='checkbox']:indeterminate {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

@media (forced-colors: active)  {

  [type='checkbox']:indeterminate {
    appearance: auto;
  }
}

[type='checkbox']:indeterminate:hover,[type='checkbox']:indeterminate:focus {
  border-color: transparent;
  background-color: currentColor;
}

[type='file'] {
  background: unset;
  border-color: inherit;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-size: unset;
  line-height: inherit;
}

[type='file']:focus {
  outline: 1px solid ButtonText;
  outline: 1px auto -webkit-focus-ring-color;
}
  [type='text'], input:where(:not([type])), [type='email'], [type='url'], [type='password'], [type='number'],
  [type='date'], [type='datetime-local'], [type='month'], [type='search'], [type='tel'], [type='time'], [type='week'],
  [multiple], textarea, select {
    font-size: inherit;
    line-height: inherit;
  }
.\\!container {
  width: 100% !important;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .\\!container {
    max-width: 640px !important;
  }

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .\\!container {
    max-width: 768px !important;
  }

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .\\!container {
    max-width: 1024px !important;
  }

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .\\!container {
    max-width: 1280px !important;
  }

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .\\!container {
    max-width: 1536px !important;
  }

  .container {
    max-width: 1536px;
  }
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-right-0\\.5 {
  right: -0.125rem;
}
.-top-0\\.5 {
  top: -0.125rem;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-0\\.5 {
  bottom: 0.125rem;
}
.bottom-10 {
  bottom: 2.5rem;
}
.left-0 {
  left: 0px;
}
.left-1\\/2 {
  left: 50%;
}
.left-4 {
  left: 1rem;
}
.right-0 {
  right: 0px;
}
.right-1 {
  right: 0.25rem;
}
.right-1\\.5 {
  right: 0.375rem;
}
.right-4 {
  right: 1rem;
}
.top-0 {
  top: 0px;
}
.top-1\\.5 {
  top: 0.375rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-2 {
  top: 0.5rem;
}
.top-4 {
  top: 1rem;
}
.top-\\[calc\\(100\\%\\+8px\\)\\] {
  top: calc(100% + 8px);
}
.top-full {
  top: 100%;
}
.z-10 {
  z-index: 10;
}
.z-30 {
  z-index: 30;
}
.z-50 {
  z-index: 50;
}
.z-\\[10000\\] {
  z-index: 10000;
}
.z-\\[10001\\] {
  z-index: 10001;
}
.z-\\[10002\\] {
  z-index: 10002;
}
.z-\\[1000\\] {
  z-index: 1000;
}
.z-\\[10050\\] {
  z-index: 10050;
}
.z-\\[55\\] {
  z-index: 55;
}
.z-\\[60\\] {
  z-index: 60;
}
.z-\\[65\\] {
  z-index: 65;
}
.z-\\[70\\] {
  z-index: 70;
}
.z-\\[10003\\] {
  z-index: 10003;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.m-0 {
  margin: 0px;
}
.m-4 {
  margin: 1rem;
}
.mx-0\\.5 {
  margin-left: 0.125rem;
  margin-right: 0.125rem;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-5 {
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-1\\.5 {
  margin-top: 0.375rem;
  margin-bottom: 0.375rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.-mt-1\\.5 {
  margin-top: -0.375rem;
}
.-mt-2 {
  margin-top: -0.5rem;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-2\\.5 {
  margin-bottom: 0.625rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.ml-0\\.5 {
  margin-left: 0.125rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-1\\.5 {
  margin-left: 0.375rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.ml-6 {
  margin-left: 1.5rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-1\\.5 {
  margin-right: 0.375rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-auto {
  margin-right: auto;
}
.mt-0 {
  margin-top: 0px;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.-mb-px {
  margin-bottom: -1px;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.\\!table {
  display: table !important;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.\\!hidden {
  display: none !important;
}
.hidden {
  display: none;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-3 {
  height: 0.75rem;
}
.h-4 {
  height: 1rem;
}
.h-40 {
  height: 10rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[22px\\] {
  height: 22px;
}
.h-\\[37px\\] {
  height: 37px;
}
.h-\\[5\\.5rem\\] {
  height: 5.5rem;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-\\[60vh\\] {
  height: 60vh;
}
.h-\\[640px\\] {
  height: 640px;
}
.h-\\[72vh\\] {
  height: 72vh;
}
.h-\\[75vh\\] {
  height: 75vh;
}
.h-\\[76vh\\] {
  height: 76vh;
}
.h-\\[78vh\\] {
  height: 78vh;
}
.h-\\[80vh\\] {
  height: 80vh;
}
.h-\\[82vh\\] {
  height: 82vh;
}
.h-\\[84vh\\] {
  height: 84vh;
}
.h-\\[88vh\\] {
  height: 88vh;
}
.h-\\[calc\\(100\\%-3rem\\)\\] {
  height: calc(100% - 3rem);
}
.h-\\[calc\\(100vh-40px\\)\\] {
  height: calc(100vh - 40px);
}
.h-full {
  height: 100%;
}
.h-screen {
  height: 100vh;
}
.h-\\[38\\%\\] {
  height: 38%;
}
.max-h-24 {
  max-height: 6rem;
}
.max-h-28 {
  max-height: 7rem;
}
.max-h-32 {
  max-height: 8rem;
}
.max-h-40 {
  max-height: 10rem;
}
.max-h-48 {
  max-height: 12rem;
}
.max-h-52 {
  max-height: 13rem;
}
.max-h-56 {
  max-height: 14rem;
}
.max-h-64 {
  max-height: 16rem;
}
.max-h-72 {
  max-height: 18rem;
}
.max-h-\\[360px\\] {
  max-height: 360px;
}
.max-h-\\[420px\\] {
  max-height: 420px;
}
.max-h-\\[440px\\] {
  max-height: 440px;
}
.max-h-\\[60vh\\] {
  max-height: 60vh;
}
.max-h-\\[620px\\] {
  max-height: 620px;
}
.max-h-\\[70vh\\] {
  max-height: 70vh;
}
.max-h-\\[80vh\\] {
  max-height: 80vh;
}
.max-h-\\[84vh\\] {
  max-height: 84vh;
}
.max-h-\\[85vh\\] {
  max-height: 85vh;
}
.max-h-\\[88vh\\] {
  max-height: 88vh;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.min-h-0 {
  min-height: 0px;
}
.w-1 {
  width: 0.25rem;
}
.w-1\\.5 {
  width: 0.375rem;
}
.w-10 {
  width: 2.5rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-32 {
  width: 8rem;
}
.w-36 {
  width: 9rem;
}
.w-4 {
  width: 1rem;
}
.w-40 {
  width: 10rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-52 {
  width: 13rem;
}
.w-56 {
  width: 14rem;
}
.w-6 {
  width: 1.5rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-8 {
  width: 2rem;
}
.w-80 {
  width: 20rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[1000px\\] {
  width: 1000px;
}
.w-\\[104px\\] {
  width: 104px;
}
.w-\\[1100px\\] {
  width: 1100px;
}
.w-\\[112px\\] {
  width: 112px;
}
.w-\\[1180px\\] {
  width: 1180px;
}
.w-\\[1280px\\] {
  width: 1280px;
}
.w-\\[130px\\] {
  width: 130px;
}
.w-\\[150px\\] {
  width: 150px;
}
.w-\\[160px\\] {
  width: 160px;
}
.w-\\[170px\\] {
  width: 170px;
}
.w-\\[180px\\] {
  width: 180px;
}
.w-\\[220px\\] {
  width: 220px;
}
.w-\\[26\\%\\] {
  width: 26%;
}
.w-\\[26rem\\] {
  width: 26rem;
}
.w-\\[34\\%\\] {
  width: 34%;
}
.w-\\[34rem\\] {
  width: 34rem;
}
.w-\\[36\\%\\] {
  width: 36%;
}
.w-\\[38\\%\\] {
  width: 38%;
}
.w-\\[380px\\] {
  width: 380px;
}
.w-\\[40\\%\\] {
  width: 40%;
}
.w-\\[420px\\] {
  width: 420px;
}
.w-\\[440px\\] {
  width: 440px;
}
.w-\\[480px\\] {
  width: 480px;
}
.w-\\[520px\\] {
  width: 520px;
}
.w-\\[560px\\] {
  width: 560px;
}
.w-\\[640px\\] {
  width: 640px;
}
.w-\\[7\\.25rem\\] {
  width: 7.25rem;
}
.w-\\[700px\\] {
  width: 700px;
}
.w-\\[720px\\] {
  width: 720px;
}
.w-\\[760px\\] {
  width: 760px;
}
.w-\\[780px\\] {
  width: 780px;
}
.w-\\[820px\\] {
  width: 820px;
}
.w-\\[860px\\] {
  width: 860px;
}
.w-\\[900px\\] {
  width: 900px;
}
.w-\\[920px\\] {
  width: 920px;
}
.w-\\[960px\\] {
  width: 960px;
}
.w-\\[980px\\] {
  width: 980px;
}
.w-auto {
  width: auto;
}
.w-full {
  width: 100%;
}
.w-px {
  width: 1px;
}
.w-\\[48\\%\\] {
  width: 48%;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-\\[16rem\\] {
  min-width: 16rem;
}
.min-w-\\[18rem\\] {
  min-width: 18rem;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-\\[220px\\] {
  min-width: 220px;
}
.min-w-\\[280px\\] {
  min-width: 280px;
}
.min-w-\\[320px\\] {
  min-width: 320px;
}
.min-w-\\[7rem\\] {
  min-width: 7rem;
}
.min-w-full {
  min-width: 100%;
}
.max-w-\\[10rem\\] {
  max-width: 10rem;
}
.max-w-\\[14rem\\] {
  max-width: 14rem;
}
.max-w-\\[16rem\\] {
  max-width: 16rem;
}
.max-w-\\[18rem\\] {
  max-width: 18rem;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[260px\\] {
  max-width: 260px;
}
.max-w-\\[280px\\] {
  max-width: 280px;
}
.max-w-\\[420px\\] {
  max-width: 420px;
}
.max-w-\\[45\\%\\] {
  max-width: 45%;
}
.max-w-\\[600px\\] {
  max-width: 600px;
}
.max-w-\\[60px\\] {
  max-width: 60px;
}
.max-w-\\[640px\\] {
  max-width: 640px;
}
.max-w-\\[90vw\\] {
  max-width: 90vw;
}
.max-w-\\[92vw\\] {
  max-width: 92vw;
}
.max-w-\\[95vw\\] {
  max-width: 95vw;
}
.max-w-\\[96vw\\] {
  max-width: 96vw;
}
.max-w-full {
  max-width: 100%;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xl {
  max-width: 36rem;
}
.max-w-\\[97vw\\] {
  max-width: 97vw;
}
.flex-1 {
  flex: 1 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink {
  flex-shrink: 1;
}
.shrink-0 {
  flex-shrink: 0;
}
.border-collapse {
  border-collapse: collapse;
}
.origin-top-left {
  transform-origin: top left;
}
.origin-top-right {
  transform-origin: top right;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1 {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-2 {
  --tw-translate-y: 0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95 {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[0\\.98\\] {
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.\\!cursor-not-allowed {
  cursor: not-allowed !important;
}
.cursor-col-resize {
  cursor: col-resize;
}
.cursor-move {
  cursor: move;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-row-resize {
  cursor: row-resize;
}
.cursor-text {
  cursor: text;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.select-all {
  -webkit-user-select: all;
          user-select: all;
}
.resize-none {
  resize: none;
}
.resize {
  resize: both;
}
.list-decimal {
  list-style-type: decimal;
}
.list-disc {
  list-style-type: disc;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-\\[130px_1fr\\] {
  grid-template-columns: 130px 1fr;
}
.grid-cols-\\[140px_1fr\\] {
  grid-template-columns: 140px 1fr;
}
.grid-cols-\\[1fr_320px\\] {
  grid-template-columns: 1fr 320px;
}
.grid-cols-\\[220px_1fr\\] {
  grid-template-columns: 220px 1fr;
}
.grid-cols-\\[240px_1fr\\] {
  grid-template-columns: 240px 1fr;
}
.grid-cols-\\[240px_1fr_280px\\] {
  grid-template-columns: 240px 1fr 280px;
}
.grid-cols-\\[300px_360px_1fr\\] {
  grid-template-columns: 300px 360px 1fr;
}
.grid-cols-\\[420px_1fr\\] {
  grid-template-columns: 420px 1fr;
}
.grid-cols-\\[52px_1fr\\] {
  grid-template-columns: 52px 1fr;
}
.grid-cols-\\[64px_1fr\\] {
  grid-template-columns: 64px 1fr;
}
.grid-cols-\\[6rem_1fr\\] {
  grid-template-columns: 6rem 1fr;
}
.grid-cols-\\[minmax\\(0\\2c 5fr\\)_minmax\\(0\\2c 6fr\\)\\] {
  grid-template-columns: minmax(0,5fr) minmax(0,6fr);
}
.grid-cols-\\[1fr_380px\\] {
  grid-template-columns: 1fr 380px;
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-0 {
  gap: 0px;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-x-1 {
  column-gap: 0.25rem;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.gap-x-3 {
  column-gap: 0.75rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.gap-x-6 {
  column-gap: 1.5rem;
}
.gap-y-0\\.5 {
  row-gap: 0.125rem;
}
.gap-y-1 {
  row-gap: 0.25rem;
}
.gap-y-1\\.5 {
  row-gap: 0.375rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.divide-x > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(var(--c-gray-100) / var(--tw-divide-opacity, 1));
}
.divide-gray-200 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(var(--c-gray-200) / var(--tw-divide-opacity, 1));
}
.self-center {
  align-self: center;
}
.self-stretch {
  align-self: stretch;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.whitespace-normal {
  white-space: normal;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre {
  white-space: pre;
}
.whitespace-pre-line {
  white-space: pre-line;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 4px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 6px;
}
.rounded-md {
  border-radius: 4px;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.rounded-b-md {
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}
.rounded-t {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.rounded-bl-md {
  border-bottom-left-radius: 4px;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-l {
  border-left-width: 1px;
}
.border-l-2 {
  border-left-width: 2px;
}
.border-r {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-0 {
  border-top-width: 0px;
}
.border-b-0 {
  border-bottom-width: 0px;
}
.border-dashed {
  border-style: dashed;
}
.border-none {
  border-style: none;
}
.border-amber-200 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-amber-200) / var(--tw-border-opacity, 1));
}
.border-amber-300 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-amber-300) / var(--tw-border-opacity, 1));
}
.border-amber-400 {
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / var(--tw-border-opacity, 1));
}
.border-amber-500 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-amber-500) / var(--tw-border-opacity, 1));
}
.border-blue-100 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-blue-100) / var(--tw-border-opacity, 1));
}
.border-blue-200 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-blue-200) / var(--tw-border-opacity, 1));
}
.border-blue-300 {
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}
.border-blue-400 {
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-blue-500) / var(--tw-border-opacity, 1));
}
.border-blue-600 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-blue-600) / var(--tw-border-opacity, 1));
}
.border-emerald-200 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-emerald-200) / var(--tw-border-opacity, 1));
}
.border-emerald-300 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-emerald-300) / var(--tw-border-opacity, 1));
}
.border-emerald-600 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-emerald-600) / var(--tw-border-opacity, 1));
}
.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-gray-100) / var(--tw-border-opacity, 1));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-gray-200) / var(--tw-border-opacity, 1));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-gray-300) / var(--tw-border-opacity, 1));
}
.border-gray-50 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-gray-50) / var(--tw-border-opacity, 1));
}
.border-green-100 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-green-100) / var(--tw-border-opacity, 1));
}
.border-green-200 {
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.border-green-400 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-green-400) / var(--tw-border-opacity, 1));
}
.border-red-100 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-red-100) / var(--tw-border-opacity, 1));
}
.border-red-200 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-red-200) / var(--tw-border-opacity, 1));
}
.border-red-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.border-red-400 {
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1));
}
.border-red-600 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-red-600) / var(--tw-border-opacity, 1));
}
.border-transparent {
  border-color: transparent;
}
.border-violet-300 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-violet-300) / var(--tw-border-opacity, 1));
}
.border-violet-400 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-violet-400) / var(--tw-border-opacity, 1));
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-white) / var(--tw-border-opacity, 1));
}
.bg-amber-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-amber-100) / var(--tw-bg-opacity, 1));
}
.bg-amber-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-amber-50) / var(--tw-bg-opacity, 1));
}
.bg-amber-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-amber-500) / var(--tw-bg-opacity, 1));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-blue-100) / var(--tw-bg-opacity, 1));
}
.bg-blue-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}
.bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-blue-50) / var(--tw-bg-opacity, 1));
}
.bg-blue-50\\/40 {
  background-color: rgb(var(--c-blue-50) / 0.4);
}
.bg-blue-50\\/60 {
  background-color: rgb(var(--c-blue-50) / 0.6);
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-blue-500) / var(--tw-bg-opacity, 1));
}
.bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-blue-600) / var(--tw-bg-opacity, 1));
}
.bg-blue-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-blue-800) / var(--tw-bg-opacity, 1));
}
.bg-emerald-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-emerald-50) / var(--tw-bg-opacity, 1));
}
.bg-emerald-50\\/50 {
  background-color: rgb(var(--c-emerald-50) / 0.5);
}
.bg-emerald-50\\/60 {
  background-color: rgb(var(--c-emerald-50) / 0.6);
}
.bg-emerald-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-emerald-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-emerald-600) / var(--tw-bg-opacity, 1));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-gray-100) / var(--tw-bg-opacity, 1));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-gray-200) / var(--tw-bg-opacity, 1));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-gray-300) / var(--tw-bg-opacity, 1));
}
.bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-gray-400) / var(--tw-bg-opacity, 1));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-gray-50) / var(--tw-bg-opacity, 1));
}
.bg-gray-50\\/60 {
  background-color: rgb(var(--c-gray-50) / 0.6);
}
.bg-gray-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-gray-700) / var(--tw-bg-opacity, 1));
}
.bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-gray-800) / var(--tw-bg-opacity, 1));
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-green-100) / var(--tw-bg-opacity, 1));
}
.bg-green-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-green-400) / var(--tw-bg-opacity, 1));
}
.bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-green-500) / var(--tw-bg-opacity, 1));
}
.bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-green-600) / var(--tw-bg-opacity, 1));
}
.bg-green-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-green-800) / var(--tw-bg-opacity, 1));
}
.bg-indigo-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-purple-800) / var(--tw-bg-opacity, 1));
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-red-100) / var(--tw-bg-opacity, 1));
}
.bg-red-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 165 165 / var(--tw-bg-opacity, 1));
}
.bg-red-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}
.bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-red-50) / var(--tw-bg-opacity, 1));
}
.bg-red-50\\/60 {
  background-color: rgb(var(--c-red-50) / 0.6);
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-red-600) / var(--tw-bg-opacity, 1));
}
.bg-transparent {
  background-color: transparent;
}
.bg-violet-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-violet-100) / var(--tw-bg-opacity, 1));
}
.bg-violet-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-violet-50) / var(--tw-bg-opacity, 1));
}
.bg-violet-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-violet-600) / var(--tw-bg-opacity, 1));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-white) / var(--tw-bg-opacity, 1));
}
.bg-white\\/60 {
  background-color: rgb(var(--c-white) / 0.6);
}
.bg-white\\/70 {
  background-color: rgb(var(--c-white) / 0.7);
}
.bg-white\\/80 {
  background-color: rgb(var(--c-white) / 0.8);
}
.bg-red-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-red-200) / var(--tw-bg-opacity, 1));
}
.bg-opacity-0 {
  --tw-bg-opacity: 0;
}
.bg-opacity-30 {
  --tw-bg-opacity: 0.3;
}
.bg-opacity-40 {
  --tw-bg-opacity: 0.4;
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.bg-opacity-70 {
  --tw-bg-opacity: 0.7;
}
.fill-gray-200 {
  fill: rgb(var(--c-gray-200) / 1);
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.px-0\\.5 {
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.py-px {
  padding-top: 1px;
  padding-bottom: 1px;
}
.pb-0\\.5 {
  padding-bottom: 0.125rem;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-1\\.5 {
  padding-bottom: 0.375rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pl-9 {
  padding-left: 2.25rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-40 {
  padding-right: 10rem;
}
.pr-7 {
  padding-right: 1.75rem;
}
.pt-0\\.5 {
  padding-top: 0.125rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-1\\.5 {
  padding-top: 0.375rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.align-top {
  vertical-align: top;
}
.align-middle {
  vertical-align: middle;
}
.font-mono {
  font-family: Consolas, Monaco, "Courier New", monospace;
}
.font-sans {
  font-family: "Segoe UI", -apple-system, BlinkMacSystemFont, sans-serif;
}
.text-2xl {
  font-size: 1.125rem;
  line-height: 1.5rem;
}
.text-2xs {
  font-size: 0.625rem;
  line-height: 0.875rem;
}
.text-\\[0\\.5625rem\\] {
  font-size: 0.5625rem;
}
.text-\\[0\\.625rem\\] {
  font-size: 0.625rem;
}
.text-\\[0\\.6875rem\\] {
  font-size: 0.6875rem;
}
.text-\\[0\\.75rem\\] {
  font-size: 0.75rem;
}
.text-\\[0\\.8125rem\\] {
  font-size: 0.8125rem;
}
.text-base {
  font-size: 0.8125rem;
  line-height: 1.25rem;
}
.text-lg {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-sm {
  font-size: 0.75rem;
  line-height: 1.125rem;
}
.text-xl {
  font-size: 1rem;
  line-height: 1.375rem;
}
.text-xs {
  font-size: 0.6875rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-4 {
  line-height: 1rem;
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-\\[13px\\] {
  line-height: 13px;
}
.leading-none {
  line-height: 1;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.text-amber-500 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-amber-500) / var(--tw-text-opacity, 1));
}
.text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-amber-600) / var(--tw-text-opacity, 1));
}
.text-amber-700 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-amber-700) / var(--tw-text-opacity, 1));
}
.text-amber-700\\/80 {
  color: rgb(var(--c-amber-700) / 0.8);
}
.text-amber-800 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-amber-800) / var(--tw-text-opacity, 1));
}
.text-amber-900 {
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity, 1));
}
.text-blue-300 {
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-blue-500) / var(--tw-text-opacity, 1));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-blue-600) / var(--tw-text-opacity, 1));
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-blue-700) / var(--tw-text-opacity, 1));
}
.text-blue-800 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-blue-800) / var(--tw-text-opacity, 1));
}
.text-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-blue-900) / var(--tw-text-opacity, 1));
}
.text-emerald-700 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-emerald-700) / var(--tw-text-opacity, 1));
}
.text-emerald-800 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-emerald-800) / var(--tw-text-opacity, 1));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-gray-300) / var(--tw-text-opacity, 1));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-gray-400) / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-gray-500) / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-gray-600) / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-gray-700) / var(--tw-text-opacity, 1));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-gray-800) / var(--tw-text-opacity, 1));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-gray-900) / var(--tw-text-opacity, 1));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-green-500) / var(--tw-text-opacity, 1));
}
.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-green-600) / var(--tw-text-opacity, 1));
}
.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-green-700) / var(--tw-text-opacity, 1));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-green-800) / var(--tw-text-opacity, 1));
}
.text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.text-indigo-700 {
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.text-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-purple-500) / var(--tw-text-opacity, 1));
}
.text-purple-600 {
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.text-purple-700 {
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-red-600) / var(--tw-text-opacity, 1));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-red-700) / var(--tw-text-opacity, 1));
}
.text-red-800 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-red-800) / var(--tw-text-opacity, 1));
}
.text-violet-700 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-violet-700) / var(--tw-text-opacity, 1));
}
.text-violet-800 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-violet-800) / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(var(--c-white) / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.line-through {
  text-decoration-line: line-through;
}
.no-underline {
  text-decoration-line: none;
}
.decoration-dotted {
  text-decoration-style: dotted;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-40 {
  opacity: 0.4;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-70 {
  opacity: 0.7;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-blue-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(147 197 253 / var(--tw-ring-opacity, 1));
}
.ring-blue-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(96 165 250 / var(--tw-ring-opacity, 1));
}
.ring-blue-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--c-blue-500) / var(--tw-ring-opacity, 1));
}
.ring-white {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--c-white) / var(--tw-ring-opacity, 1));
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[width\\] {
  transition-property: width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.\\[writing-mode\\:vertical-rl\\] {
  writing-mode: vertical-rl;
}

/* 입력란 글자 크기 — @tailwindcss/forms 는 글자 크기를 따로 주지 않은 입력란을 1rem(줄 높이 1.5rem)으로 만든다.
   이 화면의 기본 글자는 0.75rem 이라, text-xs·text-sm 을 붙이지 않은 칸만 유독 크게 보였다(현장 2026-10-12:
   실행 노드의 제한(초)·실행 전 대기·변수 값 칸 등 여기저기). 칸마다 고치지 않고, 크기를 주지 않은 입력란은
   **둘레 글자 크기를 따르게** 한다. text-* 를 붙인 칸은 그대로다(유틸리티가 base 보다 뒤라 이긴다). */

/* ──────────────────────────────────────────────────────────────
 * 테마 팔레트
 * tailwind.config.js 가 white / gray-* / blue·red·amber 일부를 이 변수로 연결한다.
 * :root = 라이트(Tailwind 기본값 그대로), .dark = 다크(회색 스케일을 뒤집음).
 * 값은 "R G B" 공백 구분 — Tailwind 의 <alpha-value> 합성용.
 * ────────────────────────────────────────────────────────────── */
:root {
  color-scheme: light;
  /* LiveSQL 라이트: bg #fff / #f5f6f8 / #e8ecf0, border #ddd, text #333 / #666 / #999 */
  --c-white: 255 255 255;
  --c-surface: 255 255 255;
  --c-gray-50: 245 246 248;
  --c-gray-100: 232 236 240;
  --c-gray-200: 221 221 221;
  --c-gray-300: 204 204 204;
  --c-gray-400: 153 153 153;
  --c-gray-500: 102 102 102;
  --c-gray-600: 85 85 85;
  --c-gray-700: 51 51 51;
  --c-gray-800: 40 40 40;
  --c-gray-900: 30 30 30;
  --c-blue-50: 239 246 255;
  --c-blue-100: 219 234 254;
  --c-blue-200: 191 219 254;
  --c-blue-500: 59 130 246;
  --c-blue-600: 37 99 235;
  --c-blue-700: 29 78 216;
  --c-blue-800: 30 64 175;
  --c-blue-900: 30 58 138;
  --c-red-50: 254 242 242;
  --c-red-100: 254 226 226;
  --c-red-200: 254 202 202;
  --c-red-600: 220 38 38;
  --c-red-700: 185 28 28;
  --c-red-800: 153 27 27;
  --c-amber-50: 255 251 235;
  --c-amber-100: 254 243 199;
  --c-amber-200: 253 230 138;
  --c-amber-300: 252 211 77;
  --c-amber-500: 245 158 11;
  --c-amber-600: 217 119 6;
  --c-amber-700: 180 83 9;
  --c-amber-800: 146 64 14;
  --c-violet-50: 245 243 255;
  --c-violet-100: 237 233 254;
  --c-violet-300: 196 181 253;
  --c-violet-400: 167 139 250;
  --c-violet-600: 124 58 237;
  --c-violet-700: 109 40 217;
  --c-violet-800: 91 33 182;
  --c-purple-500: 168 85 247;
  --c-purple-800: 107 33 168;
  --c-green-100: 220 252 231;
  --c-green-400: 74 222 128;
  --c-green-500: 34 197 94;
  --c-green-600: 22 163 74;
  --c-green-700: 21 128 61;
  --c-green-800: 22 101 52;
  --c-emerald-50: 236 253 245;
  --c-emerald-100: 209 250 229;
  --c-emerald-200: 167 243 208;
  --c-emerald-300: 110 231 183;
  --c-emerald-600: 5 150 105;
  --c-emerald-700: 4 120 87;
  --c-emerald-800: 6 95 70;

  /* 캔버스 전용 */
  --edge-stroke: #555;
  --xy-background-pattern-dots-color: #bbb;
}

.dark {
  color-scheme: dark;
  /* LiveSQL 다크 = VS Code 팔레트: bg #1e1e1e / #252526 / #2d2d2d, border #404040,
     text #d4d4d4 / #aaa / #777, accent #007acc, hover #37373d, active #094771 */
  --c-white: 255 255 255;   /* text-white 는 흰색 유지, 표면은 --c-surface */
  --c-surface: 37 37 38;    /* 카드·패널·입력창 (#252526) */
  --c-gray-50: 30 30 30;    /* 페이지 바닥 (#1e1e1e) */
  --c-gray-100: 45 45 45;   /* 탭·헤더 (#2d2d2d) */
  --c-gray-200: 64 64 64;   /* 경계선 (#404040) */
  --c-gray-300: 85 85 85;   /* 입력창 테두리 (#555) */
  --c-gray-400: 119 119 119; /* muted (#777) */
  --c-gray-500: 170 170 170; /* 보조 텍스트 (#aaa) */
  --c-gray-600: 200 200 200;
  --c-gray-700: 212 212 212; /* 본문 텍스트 (#d4d4d4) */
  --c-gray-800: 230 230 230;
  --c-gray-900: 240 240 240;
  --c-blue-50: 9 71 113;     /* 선택 배경 (#094771) */
  --c-blue-100: 26 58 92;
  --c-blue-200: 38 79 120;
  --c-blue-500: 0 122 204;   /* accent #007acc */
  --c-blue-600: 0 98 163;
  --c-blue-700: 108 182 255;
  --c-blue-800: 160 205 255;
  --c-blue-900: 200 225 255;
  --c-red-50: 74 21 27;
  --c-red-100: 90 30 32;
  --c-red-200: 122 34 40;
  --c-red-600: 229 115 115;
  --c-red-700: 255 138 128;
  --c-red-800: 255 170 160;
  --c-amber-50: 50 36 8;
  --c-amber-100: 69 44 3;
  --c-amber-200: 100 66 10;
  --c-amber-300: 160 100 20;
  --c-amber-500: 245 158 11;
  --c-amber-600: 251 191 36;
  --c-amber-700: 252 211 77;
  --c-amber-800: 255 213 79;
  /* AI 패널(violet)·성공/적합(green, emerald) — 어두운 틴트 + 밝은 텍스트 */
  --c-violet-50: 46 36 74;
  --c-violet-100: 58 45 96;
  --c-violet-300: 110 86 170;
  --c-violet-400: 139 116 200;
  --c-violet-600: 167 139 250;
  --c-violet-700: 196 181 253;
  --c-violet-800: 221 214 254;
  --c-purple-500: 192 132 252;
  --c-purple-800: 233 213 255;
  --c-green-100: 20 60 36;
  --c-green-400: 74 222 128;
  --c-green-500: 52 199 110;
  --c-green-600: 110 231 160;
  --c-green-700: 134 239 172;
  --c-green-800: 187 247 208;
  --c-emerald-50: 16 48 40;
  --c-emerald-100: 22 64 52;
  --c-emerald-200: 30 90 72;
  --c-emerald-300: 52 140 110;
  --c-emerald-600: 52 211 153;
  --c-emerald-700: 110 231 183;
  --c-emerald-800: 167 243 208;

  --edge-stroke: #9a9a9a;
  --xy-background-pattern-dots-color: #3a3a3a;
}

@keyframes flow {
  from {
    stroke-dashoffset: 10;
  }
  to {
    stroke-dashoffset: 0;
  }
}

/* 전역 배율 — 오픈데이터모델러와 같은 90%. rem 으로 쓴 글자·여백·아이콘이 함께 줄어든다.
   글자 크기는 tailwind.config.js 와 이 파일에서 rem 으로 쓴다(px 로 쓰면 배율을 따라가지 않는다).
   캔버스 도형(노드 150×80, 핸들 등)은 캔버스 확대/축소를 따르므로 px 그대로 둔다. */
html {
  font-size: 90%;
}

body {
  margin: 0;
  background-color: rgb(var(--c-gray-50));
  color: rgb(var(--c-gray-900));
  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 0.75rem;
  line-height: 1.125rem;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.react-flow__node {
  padding: 10px;
  border-radius: 3px;
  width: 205px;
  font-size: 12px;
  color: #222;
  text-align: center;
  border-width: 1px;
  border-style: solid;

  /* 하위 요소들을 중앙 정렬하기 위한 속성 추가 */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;  

  /* 배경색을 밝은 회색으로 설정 */
  background-color: #f0f0f0; /* 밝은 회색 */  
}

.react-flow__node-input {
  background: #fff;
  border-color: #0041d0;
}

.react-flow__node-output {
  background: #fff;
  border-color: #ff0072;
}

.react-flow__node-default {
  background: #fff;
  border-color: #1a192b;
}


/* 프로세스, 컨트롤 노드들에 대한 스타일 */
.react-flow__node-filter,
.react-flow__node-join,
.react-flow__node-dbExtract,
.react-flow__node-csvExtract,
.react-flow__node-dbLoad,
.react-flow__node-csvLoad,
.react-flow__node-processLoad,
.react-flow__node-branch,
.react-flow__node-merge,
.react-flow__node-userConfirm {
  background-color: #f0f0f0; /* 밝은 회색 */  
  border-radius: 42px !important;
}

/* 컨트롤 노드 타입별 테두리 색상 */
.react-flow__node-branch {
  border-color: #ff9800 !important;
}

.react-flow__node-merge {
  border-color: #2196f3 !important;
}

.react-flow__node-userConfirm {
  border-color: #9c27b0 !important;
}

/* Group Node Base Styles - high specificity to override React Flow defaults */
.react-flow__node.react-flow__node-group,
.react-flow__node.react-flow__node-subflow,
.react-flow__node.react-flow__node-repeatGroup {
  cursor: grab !important;
  -webkit-user-select: none !important;
          user-select: none !important;
  /* React Flow 노드는 모두 absolute — relative 로 두면 그룹이 노드 레이어의 일반 흐름을 차지해
     DOM 상 뒤에 오는 노드들(top:auto)이 그룹 높이만큼 아래로 밀려 자식이 그룹 밖에 그려졌다 */
  position: absolute !important;
  z-index: 0 !important;
  border-radius: 8px !important;
  /* 래퍼는 도형을 그리지 않는다 — 테두리·배경·패딩은 BaseGroupNode(.group-node) 하나가 담당.
     (예전엔 래퍼 1px 테두리+30px 패딩 안에 또 하나의 박스가 있어 외곽선이 2겹으로 보였다.
      패딩을 없애면 자식 좌표(부모 원점 기준)와 박스 원점이 일치해 자동 배치/자동 크기 계산도 단순해진다) */
  padding: 0 !important;
  border: none !important;
  background: transparent !important;
  overflow: visible !important;
  box-sizing: border-box !important;
  transform-origin: top left !important;
}

/* 그룹 크기는 노드 style(width/height) 이 정한다 — 자동(자식에 맞춤)/수동(리사이저) 모드. 고정 크기 CSS 는 두지 않는다 */

/* Group node content area styles */
/* 그룹의 연결점은 안쪽 영역(.group-content, z-index 1) 위에 — 아래쪽 점의 윗부분이 안쪽 영역에 가려졌다 */
.group-node > .react-flow__handle { z-index: 2; }

.group-content,
div[data-content-for] {
  position: relative !important;
  height: calc(100% - 40px) !important;
  width: calc(100% - 20px) !important;
  margin: 10px auto 0 !important;
  padding: 10px !important;
  overflow: visible !important;
  box-sizing: border-box !important;
  z-index: 1 !important;
}

/* Parent-child positioning fixes */
.react-flow__node[data-parent-id] {
  z-index: 10 !important;
  position: absolute !important;
}

/* Debug borders for visual guidance in development */
.react-flow__node[data-dev-mode="true"] {
  outline: 2px dashed rgba(255, 0, 0, 0.3);
}

.react-flow__node[data-dev-mode="true"] .group-content {
  outline: 2px dashed rgba(0, 0, 255, 0.3);
}

/* Selected group nodes styling */
.react-flow__node-group.selected,
.react-flow__node-subflow.selected,
.react-flow__node-repeatGroup.selected {
  border-color: #3772FF !important;
  border-width: 2px !important;
  box-shadow: none !important;   /* 테두리(.group-node 2px) 하나로 — 바깥 번짐까지 겹쳐 두꺼워 보였다 */
}

/* Dragging state styling */
.react-flow__node[data-dragging="true"] {
  opacity: 0.8 !important;
  border-color: #ff9900 !important;
  box-shadow: 0 0 8px rgba(255, 153, 0, 0.5) !important;
}

/* Fix for child nodes when parent is dragging */
.react-flow__node[data-parent-dragging="true"] {
  pointer-events: none !important;   /* 흐리게·뒤로 보내지 않는다 — 그룹을 끄는 동안 안쪽이 가려져 보였다 */
}

/* Positioning grid for visualization (dev only) */
.react-flow__node[data-dev-mode="true"]::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    linear-gradient(to right, rgba(0,0,0,0.05) 1px, transparent 1px),
    linear-gradient(to bottom, rgba(0,0,0,0.05) 1px, transparent 1px);
  background-size: 20px 20px;
  pointer-events: none;
  z-index: 0;
}

.react-flow__handle {
  /* 연결을 시작하는 자리라 **손으로 맞출 수 있을 만큼** 커야 한다 — 8px 은 조준이 어려웠다(현장 2026-09-22).
     노드가 쓰는 w-4/h-4 는 React Flow 기본값과 같은 자리라 이 규칙이 이긴다. 여기서 크기를 정한다. */
  width: 14px;
  height: 14px;
  /* 회색 — 노드 내용보다 눈에 띄지 않게. 연결할 때만 강조된다(아래 :hover·connecting) */
  background: #9ca3af;
  border: 2px solid #fff;
}
.react-flow__handle:hover,
.react-flow__handle.connectingfrom,
.react-flow__handle.connectingto { background: #6b7280; }
/* 핸들 중심을 **테두리 선 위**에 둔다. React Flow 는 노드의 안쪽 면(테두리 안)을 0 으로 잡아서,
   노드 테두리(2px)만큼 핸들이 안으로 들어와 보였다. 테두리 두께의 절반만큼 바깥으로 민다. */
.react-flow__node .react-flow__handle-left { left: -1px; }
.react-flow__node .react-flow__handle-right { right: -1px; }
.react-flow__node .react-flow__handle-top { top: -1px; }
.react-flow__node .react-flow__handle-bottom { bottom: -1px; }

.react-flow__edge-path {
  stroke: #374151;
  stroke-width: 2;
  z-index: 11 !important;
}

.react-flow__edge-path-selector {
  stroke: transparent;
  stroke-width: 10;
  cursor: pointer;
}

.react-flow__edge.selected .react-flow__edge-path {
  stroke: #3b82f6;
}

.react-flow__node.selected {
  box-shadow: 0 0 0 2px #784be8;
}

/* 그룹 노드 선택 시 특별 스타일 */
.react-flow__node-group.selected,
.react-flow__node-subflow.selected,
.react-flow__node-repeatGroup.selected {
  box-shadow: 0 0 0 3px #784be8;
  z-index: 5 !important;
}

.workflow-node {
  border-radius: 6px;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-gray-200) / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-white) / var(--tw-bg-opacity, 1));
  padding: 0.75rem;
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark .workflow-node {
  background-color: rgb(var(--c-surface));
}

.workflow-node-header {
  margin-bottom: 0.5rem;
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-gray-100) / var(--tw-border-opacity, 1));
  padding-bottom: 0.5rem;
  font-size: 0.75rem;
  line-height: 1.125rem;
  font-weight: 600;
}

.workflow-node-content {
  font-size: 0.6875rem;
  line-height: 1rem;
  --tw-text-opacity: 1;
  color: rgb(var(--c-gray-600) / var(--tw-text-opacity, 1));
}

.property-panel {
  position: absolute;
  right: 0px;
  top: 0px;
  height: 100%;
  width: 18rem;
  border-left-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-gray-200) / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-white) / var(--tw-bg-opacity, 1));
  padding: 1rem;
}

.dark .property-panel {
  background-color: rgb(var(--c-surface));
}

.toolbox-panel {
  position: absolute;
  left: 0px;
  top: 0px;
  height: 100%;
  width: 12rem;
  border-right-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-gray-200) / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-white) / var(--tw-bg-opacity, 1));
  padding: 1rem;
}

.dark .toolbox-panel {
  background-color: rgb(var(--c-surface));
}

/* 주의: .react-flow__renderer 에 배경색을 주지 말 것 — z-index 4 라 Background 점 패턴과 워크플로명 워터마크를 가린다.
   캔버스 바닥색은 --xy-background-color(라이트 기본 흰색, 다크는 아래 .dark 블록)가 담당한다. */

/* Add gradient definition for animated edges */
.react-flow__renderer svg defs {
  position: absolute;
}

.react-flow__renderer svg defs linearGradient#animated-edge-gradient {
  --color-start: #374151;
  --color-stop: #9ca3af;
}

.react-flow__renderer svg defs linearGradient#animated-edge-gradient stop:first-child {
  stop-color: var(--color-start);
}

.react-flow__renderer svg defs linearGradient#animated-edge-gradient stop:last-child {
  stop-color: var(--color-stop);
}

/* 그룹 노드 헤더 스타일 */
.react-flow__node-group .group-node-header,
.react-flow__node-subflow .group-node-header,
.react-flow__node-repeatGroup .group-node-header {
  position: absolute;
  top: 8px;
  left: 12px;
  font-weight: 500;
  font-size: 14px;
  width: calc(100% - 24px);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  pointer-events: none;
  z-index: 10;
}

/* 그룹 노드 콘텐츠 영역 스타일 */
.react-flow__node-group .group-node-content,
.react-flow__node-subflow .group-node-content,
.react-flow__node-repeatGroup .group-node-content {
  position: relative;
  width: 100%;
  height: calc(100% - 30px);
  margin-top: 20px;
  z-index: 1;
  /* 명확한 내부 패딩 설정 */
  padding: 10px;
  /* 명확한 포지셔닝 컨텍스트 생성 */
  transform-style: preserve-3d;
  box-sizing: border-box; /* 명시적 크기 계산 */
  /* 자식 노드 영역 표시를 위한 스타일 */
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  /* 디버깅: 콘텐츠 영역 시각화 */
  outline: 1px dashed rgba(0, 0, 0, 0.3);
}

/* 예전 디버깅용 표시(왼쪽 위 파란 점, 아래 가운데 크기 글상자)는 뺐다 — 사용자에게 뜻 없는 점이 보이고
   아래 글상자는 아래쪽 연결점 윗부분을 가렸다(현장 2026-10-01) */

/* 개발 모드에서만 표시되는 디버깅 그리드 */
.react-flow__renderer[data-dev-mode="true"] .react-flow__node-group .group-node-content,
.react-flow__renderer[data-dev-mode="true"] .react-flow__node-subflow .group-node-content,
.react-flow__renderer[data-dev-mode="true"] .react-flow__node-repeatGroup .group-node-content {
  background-image: 
    linear-gradient(to right, rgba(0, 0, 255, 0.1) 1px, transparent 1px),
    linear-gradient(to bottom, rgba(0, 0, 255, 0.1) 1px, transparent 1px);
  background-size: 20px 20px;
}

/* 그룹 노드 드래그 중 스타일 */
.react-flow__node-group.dragging,
.react-flow__node-subflow.dragging,
.react-flow__node-repeatGroup.dragging {
  cursor: grabbing !important;
  /* z-index 를 올리지 않고 배경도 칠하지 않는다 — 그룹 상자가 안의 노드·연결선을 덮었다(현장 2026-10-01) */
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2) !important;
  border: 2px solid rgba(0, 122, 255, 0.5) !important;
  will-change: transform !important;
  transition: box-shadow 0.2s ease !important;
}

/* 부모 노드가 드래그 중일 때 자식 노드 스타일 */
.react-flow__node[data-parent-dragging="true"] {
  pointer-events: none !important;
  box-shadow: none !important;
} 
/* ──────────────────────────────────────────────────────────────
 * 다크 테마 — Tailwind 클래스가 아닌 고정 색상(캔버스·폼·인라인 스타일) 보정
 * ────────────────────────────────────────────────────────────── */

/* 표면: bg-white 만 어두운 표면색으로 (text-white / border-white 는 그대로 흰색) */
.dark .bg-white {
  background-color: rgb(var(--c-surface));
}
/* 투명도 변형 (bg-white/90 등) — Tailwind 가 별도 클래스로 생성하므로 각각 덮는다 */
.dark .bg-white\\/95 { background-color: rgb(var(--c-surface) / 0.95); }
.dark .bg-white\\/90 { background-color: rgb(var(--c-surface) / 0.9); }
.dark .bg-white\\/80 { background-color: rgb(var(--c-surface) / 0.8); }
.dark .bg-white\\/75 { background-color: rgb(var(--c-surface) / 0.75); }
.dark .bg-white\\/70 { background-color: rgb(var(--c-surface) / 0.7); }
.dark .bg-white\\/60 { background-color: rgb(var(--c-surface) / 0.6); }
.dark .bg-white\\/50 { background-color: rgb(var(--c-surface) / 0.5); }
.dark .hover\\:bg-white:hover {
  background-color: rgb(var(--c-surface));
}
.dark .focus\\:bg-white:focus {
  background-color: rgb(var(--c-surface));
}

/* 폼 컨트롤 (@tailwindcss/forms 가 base 레이어에서 흰 배경을 박아 넣으므로 여기서 덮는다) */
.dark input:not([type]),
.dark [type='text'],
.dark [type='email'],
.dark [type='url'],
.dark [type='password'],
.dark [type='number'],
.dark [type='date'],
.dark [type='datetime-local'],
.dark [type='month'],
.dark [type='search'],
.dark [type='tel'],
.dark [type='time'],
.dark [type='week'],
.dark [multiple],
.dark textarea,
.dark select {
  background-color: rgb(var(--c-surface));
  border-color: rgb(var(--c-gray-300));
  color: rgb(var(--c-gray-800));
}
.dark [type='checkbox'],
.dark [type='radio'] {
  background-color: rgb(var(--c-surface));
  border-color: rgb(var(--c-gray-400));
}
.dark ::placeholder {
  color: rgb(var(--c-gray-400));
}

/* React Flow 크롬 (v12 CSS 변수) */
.dark .react-flow {
  --xy-background-color: #1e1e1e;
  --xy-node-color: #d4d4d4;
  --xy-controls-button-background-color: #252526;
  --xy-controls-button-background-color-hover: #3a3a3a;
  --xy-controls-button-color: #d4d4d4;
  --xy-controls-button-color-hover: #ffffff;
  --xy-controls-button-border-color: #3a3a3a;
  --xy-controls-box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.4);
  --xy-minimap-background-color: #252526;
  --xy-minimap-mask-background-color: rgba(30, 30, 30, 0.7);
  --xy-minimap-node-background-color: #404040;
  --xy-minimap-node-stroke-color: transparent;
  --xy-attribution-background-color: rgba(30, 30, 30, 0.6);
  --xy-edge-label-background-color: #252526;
  --xy-edge-label-color: #d4d4d4;
  --xy-node-boxshadow-selected: 0 0 0 2px #784be8;
}
/* .react-flow__renderer 에 불투명 배경을 주지 않는다 — z-index 4 라 Background 점 패턴과 워터마크(z 0)를 덮어 버린다.
   캔버스 바닥색은 위의 --xy-background-color 가 이미 담당한다 (2026-09-05 실측). */
.dark .react-flow__attribution a {
  color: #9a9a9a;
}

/* 노드 */
.dark .react-flow__node {
  color: #d4d4d4;
  background-color: #252526;
  border-color: #404040;
}
.dark .react-flow__node-input,
.dark .react-flow__node-output,
.dark .react-flow__node-default,
.dark .react-flow__node-filter,
.dark .react-flow__node-join,
.dark .react-flow__node-dbExtract,
.dark .react-flow__node-csvExtract,
.dark .react-flow__node-dbLoad,
.dark .react-flow__node-csvLoad,
.dark .react-flow__node-processLoad,
.dark .react-flow__node-branch,
.dark .react-flow__node-merge,
.dark .react-flow__node-userConfirm {
  background-color: #252526;
}
.dark .react-flow__node-default {
  border-color: #555555;
}
.dark .react-flow__handle {
  background: #6b7280;
  border-color: #1e1e1e;
}
.dark .react-flow__handle:hover,
.dark .react-flow__handle.connectingfrom,
.dark .react-flow__handle.connectingto { background: #9ca3af; }

/* 그룹 노드 — BaseGroupNode 가 인라인 style 로 밝은 배경을 주므로 !important 로 덮는다 */
.dark .group-node {
  background-color: rgb(var(--c-surface)) !important;
  border-color: #404040 !important;
}
.dark .group-node.subflow-node {
  border-color: #2f7f6a !important;
}
.dark .group-node.repeatGroup-node {
  border-color: #8a5a5a !important;
}
.dark .group-node.selected {
  border-color: #3772FF !important;
}
.dark .group-header {
  background-color: #3a3a3a !important;
  color: #d4d4d4 !important;
}
.dark .subflow-node .group-header {
  background-color: #2f5f55 !important;
}
.dark .repeatGroup-node .group-header {
  background-color: #5f3f3f !important;
}
.dark .group-content {
  background-color: transparent !important;
}
.dark .node-toolbar {
  background-color: #252526 !important;
  color: #d4d4d4 !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5) !important;
}
.dark .react-flow__node-group .group-node-content,
.dark .react-flow__node-subflow .group-node-content,
.dark .react-flow__node-repeatGroup .group-node-content {
  background-color: rgba(255, 255, 255, 0.04);
  outline-color: rgba(255, 255, 255, 0.15);
}


/* 엣지 */
.dark .react-flow__edge.selected .react-flow__edge-path {
  stroke: #3794ff;
}
.dark .react-flow__renderer svg defs linearGradient#animated-edge-gradient {
  --color-start: #9a9a9a;
  --color-stop: #404040;
}

/* Chromium 자동완성이 입력창을 흰색으로 칠하는 것 방지 */
.dark input:-webkit-autofill,
.dark input:-webkit-autofill:hover,
.dark input:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0 1000px rgb(var(--c-surface)) inset;
  -webkit-text-fill-color: rgb(var(--c-gray-800));
  caret-color: rgb(var(--c-gray-800));
}

/* 포커스 시에도 표면색 유지 (브라우저 기본 포커스 배경 방지) */
.dark input:focus,
.dark textarea:focus,
.dark select:focus {
  background-color: rgb(var(--c-surface));
}

/* 스크롤바 (LiveSQL 다크와 동일) */
.dark { scrollbar-color: #555 #1e1e1e; }
.dark ::-webkit-scrollbar { background: #1e1e1e; width: 12px; height: 12px; }
.dark ::-webkit-scrollbar-track { background: #1e1e1e; }
.dark ::-webkit-scrollbar-thumb { background: #555; border-radius: 4px; border: 2px solid #1e1e1e; }
.dark ::-webkit-scrollbar-thumb:hover { background: #666; }
.dark ::-webkit-scrollbar-corner { background: #1e1e1e; }

/* 워크플로명 워터마크 (WorkflowCanvas) — 배경 위, 노드 아래. 라이트는 연회색+흰 그림자, 다크는 중간회색+검은 그림자 */
.workflow-watermark { color: #ccc; text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.5); }
.dark .workflow-watermark { color: #777; text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5); }

/* 캔버스 배율 자동/수동 토글 버튼 (React Flow Controls 안) */
.react-flow__controls-button.zoom-mode-auto svg { color: #3b82f6; }
.dark .react-flow__controls-button.zoom-mode-auto svg { color: #3794ff; }
.react-flow__controls-button.zoom-mode-manual svg { color: #f59e0b; }

/* ── 속성 패널(RJSF) 폼 컨트롤 글꼴 통일 — 브라우저 기본(13.33px, 시스템 폰트)이 아니라 UI 글꼴 12px 로 */
.rjsf,
.rjsf input,
.rjsf select,
.rjsf textarea,
.rjsf button,
.rjsf label {
  font-family: inherit;
  font-size: 0.75rem;
  line-height: 1.125rem;
}
.rjsf input:not([type='checkbox']):not([type='radio']),
.rjsf select,
.rjsf textarea {
  padding: 4px 8px;
}

/* ── 일반 노드의 React Flow 래퍼는 도형을 그리지 않는다 — 노드 컴포넌트(BaseNode) 하나가 단일 도형.
   (예전엔 래퍼가 205px 회색 사각형/알약 + 내부 150×80 둥근 사각형으로 2중 테두리처럼 보였다)
   그룹 노드(group/subflow/repeatGroup)는 래퍼가 컨테이너 역할이라 제외 */
.react-flow__node:not(.react-flow__node-group):not(.react-flow__node-subflow):not(.react-flow__node-repeatGroup) {
  padding: 0;
  width: auto;
  border: none;
  background: transparent;
  border-radius: 0;
}
.react-flow__node-filter, .react-flow__node-join, .react-flow__node-dbExtract, .react-flow__node-csvExtract,
.react-flow__node-dbLoad, .react-flow__node-csvLoad, .react-flow__node-processLoad,
.react-flow__node-branch, .react-flow__node-merge, .react-flow__node-userConfirm {
  background-color: transparent;
  border-radius: 0 !important;
}
.react-flow__node-branch, .react-flow__node-merge, .react-flow__node-userConfirm { border-color: transparent !important; }
.dark .react-flow__node {
  background-color: transparent;
  border-color: transparent;
}
/* 선택 강조는 래퍼가 아니라 도형에 — 래퍼는 도형과 같은 크기이므로 둥근 모서리만 맞춘다 */
.react-flow__node.selected:not(.react-flow__node-group):not(.react-flow__node-subflow):not(.react-flow__node-repeatGroup) {
  box-shadow: none;
}
/* 도형 자체의 파란 테두리(BaseNode border-blue-500, 2px)만으로 선택을 보인다 —
   예전엔 그 바깥에 보라색 2px 를 하나 더 둘러 4px 두 겹으로 두꺼웠다(현장 2026-10-01) */

/* ── 전역 툴팁 (components/common/TooltipLayer) — 라이트/다크 팔레트를 따른다 */
.of-tooltip {
  position: fixed;
  z-index: 20000;
  transform: translateX(-50%);
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  line-height: 1rem;
  white-space: pre-wrap;
  pointer-events: none;
  background: #1f2937;
  color: #f9fafb;
  border: 1px solid #374151;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}
.dark .of-tooltip {
  background: #3c3c3c;
  color: #e5e5e5;
  border-color: #555;
}

/* ── 메모 노드 (포스트잇) */
.memo-node { background: #fef9c3; border-color: #fde047; color: #713f12; }
.memo-node--selected { box-shadow: 0 0 0 2px #f59e0b; }

/* 이미지/PDF 내보내기 중 — 그림자를 끈다 (CanvasToolbar 가 그리는 동안만 붙인다).
   html-to-image 는 계산된 스타일을 복사하므로 그 순간 클래스로 꺼 두면 그림에 그림자가 남지 않는다. */
.of-exporting .react-flow__node,
.of-exporting .react-flow__node *,
.of-exporting .react-flow__edge * { box-shadow: none !important; filter: none !important; text-shadow: none !important; }
/* 그림에는 편집 장치(노드 위 아이콘·+ 안내)와 선택·마우스 올림 테두리를 넣지 않는다 — 그리는 순간 마우스가 노드 위에 있으면 찍혔다 */
.of-exporting .node-tools,
.of-exporting .node-stub,
.of-exporting .react-flow__nodesselection-rect,
.of-exporting .react-flow__selection { display: none !important; }
.of-exporting .react-flow__node .border-blue-500,
.of-exporting .react-flow__node .border-green-400 { border-color: rgb(var(--c-gray-200)) !important; }
/* 다크 모드에서 배경 없이 뽑을 때: 노드 밖 이름·부제만 어두운 글자로 (canvasImage darkCaptions) */
.of-export-dark-captions .node-caption__name { color: #1f2937 !important; }
.of-export-dark-captions .node-caption__sub { color: #4b5563 !important; }
.memo-node__title { color: #854d0e; }
.memo-node__text { color: #713f12; font-family: inherit; }
.memo-node__text::placeholder { color: #a16207; opacity: 0.6; }
.dark .memo-node { background: #3b3410; border-color: #6b5a12; color: #fde68a; }
.dark .memo-node__title { color: #fcd34d; }
.dark .memo-node__text { color: #fde68a; }
.dark .memo-node__text::placeholder { color: #ca8a04; }

/* ── 실행 상태 표시 (실행 버튼 → 노드별 실행대기/실행중/실행완료/실패/건너뜀) */
/* 데이터 노드의 처리 건수 — 상태 뱃지와 같은 높이, 반대쪽(오른쪽)에 둔다 */
.rows-badge { position: absolute; top: -9px; right: 8px; z-index: 15; padding: 0 6px; height: 16px; border-radius: 8px;
  font-size: 10px; font-weight: 600; line-height: 16px; color: #fff; white-space: nowrap; background: #6b7280; }

.run-badge { position: absolute; top: -9px; left: 8px; z-index: 15; display: inline-flex; align-items: center; gap: 4px;
  padding: 0 6px; height: 16px; border-radius: 8px; font-size: 10px; font-weight: 600; line-height: 16px; color: #fff; white-space: nowrap; }
.run-badge--waiting { background: #9ca3af; }
.run-badge--running { background: #2563eb; }
.run-badge--success { background: #16a34a; }
.run-badge--failed  { background: #dc2626; }
.run-badge--skipped { background: #a16207; }
.run-badge__spin { width: 8px; height: 8px; border: 2px solid rgba(255,255,255,.5); border-top-color: #fff; border-radius: 50%; animation: run-spin .8s linear infinite; }
.run-badge__dur { font-weight: 400; padding-left: 4px; border-left: 1px solid rgba(255,255,255,.45); }
@keyframes run-spin { to { transform: rotate(360deg); } }
.run-waiting { opacity: .75; }
.run-running { border-color: #2563eb !important; box-shadow: 0 0 0 3px rgba(37,99,235,.25) !important; }
.run-success { border-color: #16a34a !important; }
.run-failed  { border-color: #dc2626 !important; box-shadow: 0 0 0 3px rgba(220,38,38,.2) !important; }
.run-skipped { opacity: .55; border-style: dashed !important; }

/* ── 탐색기 미저장 변경 표시 */
.wf-dirty-dot { color: #f59e0b; font-size: 9px; margin-left: 4px; line-height: 1; }

.run-badge { cursor: pointer; }

/* ── 노드 호버 스텁: 좌/우 핸들에서 짧은 선 + '+' (클릭 → 그 쪽에 노드 추가) */
.node-stub { position: absolute; top: 50%; transform: translateY(-50%); display: flex; align-items: center; z-index: 12; cursor: pointer;
  /* 바로 사라지지 않게 — 노드를 떠나도 잠깐(0.45초) 남아 있다가 흐려진다. 노드에서 '+' 로 가는 길에 연결 핸들이 있어
     예전에는 그 위를 지나는 순간 사라져 누르기 어려웠다. 보이는 동안은 눌린다(visibility 가 늦게 꺼진다) */
  opacity: 0; visibility: hidden; transition: opacity .15s ease .45s, visibility 0s linear .6s;
  /* 위아래로 마우스가 조금 벗어나도 '+' 위에 있는 것으로 — 선(2px)만 따라가기는 어렵다 */
  padding: 10px 0; }
.node-stub--left { right: 100%; flex-direction: row-reverse; }
.node-stub--right { left: 100%; }
/* 예외 흐름의 '+' — 예외 핸들(85% 높이)에서 30° 아래로 뻗는다. 선만 기울이고 '+' 는 되돌려 똑바로 세운다 */
.node-stub--error { left: 100%; top: 85%; transform: translate(-7px, -50%) rotate(30deg); transform-origin: left center; }
.node-stub--error .node-stub__line { border-top-color: #dc2626; }
.node-stub--error .node-stub__plus { border-color: #dc2626; color: #dc2626; transform: rotate(-30deg); }
.node-stub--error .node-stub__plus:hover { background: #dc2626; color: #fff; }
.node-stub__line { width: 22px; height: 0; border-top: 2px solid #007acc; }
.node-stub__plus { position: relative; width: 20px; height: 20px; border-radius: 50%; border: 2px solid #007acc; background: rgb(var(--c-surface)); color: #007acc; display: inline-block; box-sizing: border-box;
  font-size: 0; }   /* '+' 글자는 글꼴 기준선 때문에 원 가운데에 오지 않는다 — 글자는 숨기고 막대 두 개로 정중앙에 그린다 */
.node-stub__plus::before, .node-stub__plus::after { content: ''; position: absolute; left: 50%; top: 50%; background: currentColor; transform: translate(-50%, -50%); border-radius: 1px; }
.node-stub__plus::before { width: 10px; height: 2px; }
.node-stub__plus::after { width: 2px; height: 10px; }
.node-stub__plus:hover { background: #007acc; color: #fff; }
/* 분기 전용 '+' — 뜻이 '이 갈래에 후행을 연다' 라서 일반 '+'(다음 노드 하나 추가)와 모양·색을 달리한다.
   주황 네모 + 갈라지는 선(위·아래 두 갈래). 색만 바꾸면 무슨 차이인지 알 수 없다. */
.node-stub--branch .node-stub__plus { border-radius: 4px; border-color: #d97706; color: #d97706; }
.node-stub--branch .node-stub__plus:hover { background: #d97706; color: #fff; }
.node-stub__fork { position: relative; width: 22px; height: 18px; }
.node-stub__fork::before, .node-stub__fork::after {
  content: ''; position: absolute; left: 0; width: 22px; height: 8px; border-color: #d97706; border-style: solid;
}
.node-stub__fork::before { top: 1px; border-width: 2px 0 0 2px; border-top-left-radius: 6px; }
.node-stub__fork::after { bottom: 1px; border-width: 0 0 2px 2px; border-bottom-left-radius: 6px; }

/* 마우스를 올렸을 때, 그리고 **선택한 노드**(하나만 고른 때 — 여럿이면 .of-multiselect 가 감춘다)는 '+' 를 보인다 */
.react-flow__node:hover .node-stub,
.react-flow__node.selected .node-stub { opacity: 1; visibility: visible; transition: opacity .1s ease 0s, visibility 0s linear 0s; }
.react-flow__node.dragging .node-stub, .react-flow__node.selected.dragging .node-stub { opacity: 0; visibility: hidden; transition: none; }
/* 마우스를 올린 노드는 연결선 위로 올린다.
   연결선 층(.react-flow__edges, z-index 5)이 노드 층(.react-flow__nodes, z-index 3)보다 위라서,
   노드에 붙은 '+' 가 선에 가려 눌리지 않았다 — 분기의 '+' 는 나가는 선과 같은 자리라 아예 누를 수 없었다.
   노드 하나만 올려서는 소용이 없다(층이 순서를 정한다). 그래서 **층째** 잠깐 올린다.
   (:has 안에 :has 를 넣으면 규칙 자체가 버려진다 — 브라우저가 조용히 무시한다.) */
/* 그룹(서브플로·반복그룹)에 올렸을 때는 올리지 않는다 — 그룹 상자의 배경이 안쪽 연결선을 덮는다 */
/* 그룹 안 노드(.of-in-group, WorkflowCanvas)도 올리지 않는다 — 층째 올리면 그 노드를 담은 그룹 상자의 배경도 올라가 안쪽 선을 덮는다.
   대신 그 노드에 마우스가 있는 동안 연결선이 클릭을 가로채지 않게 해 '+' 를 누를 수 있게 한다 */
.react-flow__nodes:has(.react-flow__node:not(.react-flow__node-group):not(.react-flow__node-subflow):not(.react-flow__node-repeatGroup):not(.of-in-group):hover) { z-index: 6; }
.react-flow:has(.react-flow__node.of-in-group:hover) .react-flow__edges .react-flow__edge { pointer-events: none; }
.react-flow__node:has(.node-stub):hover { z-index: 1000 !important; }
/* 마우스 아래에 노드가 있는 동안(WorkflowCanvas 가 .of-node-under 를 붙인다) 연결선은 클릭을 가로채지 않는다 —
   선 여러 개에 덮인 노드도 고르고 끌 수 있게. 선에 붙은 '+'(연결선 사이에 넣기)도 그 자리에서는 비켜 준다 */
.of-node-under .react-flow__edges .react-flow__edge,
.of-node-under .react-flow__edgelabel-renderer * { pointer-events: none !important; }
/* 연결 핸들 위에서는 '+'(노드 자동 추가) 안내를 감춘다 — 손으로 잇는 것과 자동 추가는 한 번에 하나만 뜻이 있다.
   커서가 십자(+)로 바뀌어 연결을 시작하는 자리인데 그 옆에 다른 '+' 가 떠 있으면 무엇이 눌리는지 알 수 없다. */
.react-flow__node:has(.react-flow__handle:hover) .node-stub { opacity: 0; visibility: hidden; transition: opacity .15s ease .35s, visibility 0s linear .5s; }
/* (핸들 위를 **지나가기만** 할 때는 지연 덕분에 '+' 가 남아 있다 — 핸들에 머물러 연결하려 할 때만 감춘다) */

/* 노드 위 아이콘(이력·데이터·삭제)으로 마우스를 옮기는 동안 hover 가 끊기지 않게 — 아이콘 줄 아래를
   노드까지 이어 주는 투명한 다리. 예전에는 아이콘에 닿기 전에 사라져 클릭하기 어려웠다. */
.node-tools::after { content: ''; position: absolute; left: -6px; right: -6px; top: 100%; height: 14px; }
/* 끌고 있는 노드를 놓으면 들어갈 그룹 (canvas 의 dropGroupId) — 그룹 상자에 파란 점선 테두리 */
.react-flow__node.of-drop-target > div { outline: 3px dashed #3b82f6; outline-offset: 3px; border-radius: 8px; }
/* 범위로 여럿을 고른 동안: 노드마다의 아이콘(이력·삭제)과 + 를 감춘다 — 선택 도구 막대(canvas/SelectionToolbar)가 대신한다 */
.of-multiselect .node-tools,
.of-multiselect .node-stub { display: none !important; }

/* ── 품질검사 위반 경로 핸들(아래) */
.react-flow__handle.reject-handle { background: #dc2626 !important; border-color: #fff !important; }

/* ── 탐색기 트리 펼침/접힘 애니메이션
   높이를 모르는 콘텐츠를 부드럽게 여닫기 위해 grid-template-rows 0fr↔1fr 을 전이시킨다.
   (max-height 트릭은 값 추정이 필요하고, 조건부 언마운트는 접힘이 애니메이션되지 않는다) */
.tree-collapse { display: grid; grid-template-rows: 0fr; transition: grid-template-rows .22s ease; }
.tree-collapse.open { grid-template-rows: 1fr; }
.tree-collapse > div { overflow: hidden; min-height: 0; }
.tree-chevron { display: inline-flex; transition: transform .2s ease; }
.tree-chevron.open { transform: rotate(90deg); }
/* 트리 항목 배경/글자색도 살짝 부드럽게 */
.workflow-explorer-item { transition: background-color .15s ease, color .15s ease; }

/* 그룹 접기/펼치기 — 그 순간에만 이동·크기 변화를 부드럽게.
   평소에도 켜 두면 노드를 끌 때 손가락보다 늦게 따라와 답답하다. */
.of-collapse-anim .react-flow__node {
  transition: transform .28s cubic-bezier(.22,.61,.36,1), width .28s cubic-bezier(.22,.61,.36,1), height .28s cubic-bezier(.22,.61,.36,1);
}
.of-collapse-anim .react-flow__edge path {
  transition: d .28s cubic-bezier(.22,.61,.36,1);
}

/* ── 실행 노드 도형: 사각형 + 좌우 세로줄 (순서도의 '미리 정의된 처리').
   SQL실행·외부명령어·워크플로 실행은 **다른 곳에 정의된 일을 불러 쓰는** 노드라 이 모양이 뜻에 맞는다.
   데이터(둥근 사각형)·처리(알약)와 한눈에 구분되어야 그림이 읽힌다(현장 2026-09-22). */
.node-shape-exec { position: relative; }
.node-shape-exec::before,
.node-shape-exec::after {
  content: ''; position: absolute; top: 0; bottom: 0; width: 1px;
  background: currentColor; opacity: .28; pointer-events: none;
}
.node-shape-exec::before { left: 7px; }
.node-shape-exec::after { right: 7px; }

/* ── 실행 노드의 '미리보기' 창: 캔버스와 **같은 노드 컴포넌트**로 그리되 읽기 전용으로 보인다.
   노드에 달린 편집 장치(추가 +, 이력·데이터·삭제 아이콘)와 실행 뱃지를 감춘다 —
   컴포넌트가 같아서 그대로 두면 지금 열려 있는 워크플로의 실행 상태가 섞여 보인다(노드 id 가 겹칠 수 있다). */
.of-preview .node-stub,
.of-preview .node-tools,
.of-preview .run-badge,
.of-preview .rows-badge { display: none !important; }
/* 엣지의 + 버튼처럼 '편집용 장치' 로 이미 표시해 둔 것들 — 그림으로 내보낼 때와 같은 기준으로 뺀다 */
.of-preview [data-export-skip] { display: none !important; }
.of-preview .react-flow__handle { pointer-events: none; }
.of-preview .react-flow__node { cursor: default; }

/* ── 노드 속성을 캔버스 **아래**에 둘 때: 섹션을 폭에 맞춰 여러 칸으로 흘린다 (PropertyDock).
   속성 폼은 세로로 쌓이게 만들어져 있어, 넓고 낮은 영역에 그대로 두면 한 줄로 길게 스크롤되고 옆이 빈다.
   CSS 다단은 폭이 400px 면 한 칸, 1400px 면 서너 칸이 되므로 패널마다 따로 손대지 않아도 된다.
   · 패널 맨 위(제목·노드 유형)는 모든 칸에 걸친다
   · 섹션 하나가 두 칸으로 쪼개지지 않게 한다 — 다만 기본 속성 폼(<form>)은 통째로 한 칸에 몰리지 않게
     폼 안의 항목 단위로 나눈다 */
.prop-dock--bottom .prop-scroll > div { height: auto; overflow: visible; column-width: 22rem; column-gap: 1.75rem; column-rule: 1px solid rgb(229 231 235); }
.prop-dock--bottom .prop-scroll > div > :first-child { column-span: all; }
.prop-dock--bottom .prop-scroll > div > :not(form) { page-break-inside: avoid; break-inside: avoid; }
.prop-dock--bottom .prop-scroll form .form-group,
.prop-dock--bottom .prop-scroll form .field-object > fieldset > * { page-break-inside: avoid; break-inside: avoid; }
.dark .prop-dock--bottom .prop-scroll > div { column-rule-color: #3a3a3a; }

/* ── 가리키는 손가락 (components/common/PointerOverlay) — 도움말·Quick Start·AI 에이전트가 화면의 한 곳을 가리킨다.
   클릭을 가로채지 않는다(pointer-events: none). 위치는 컴포넌트가 transform 으로 옮긴다 */
.of-pointer-layer { position: fixed; inset: 0; pointer-events: none; z-index: 10000; }
.of-pointer-hand, .of-pointer-ring, .of-pointer-bubble { position: absolute; left: 0; top: 0; opacity: 0; will-change: transform; }
.of-pointer-hand { transition: transform 90ms linear, opacity 200ms ease; }
/* 날아가기 — 천천히 출발해 부드럽게 내려앉는다. 시간은 요청마다(--of-fly, 기본 550ms) */
.of-pointer-hand.fly, .of-pointer-bubble.fly { transition: transform var(--of-fly, 550ms) cubic-bezier(.45,.05,.25,1), opacity 200ms ease; }
.of-pointer-hand.on, .of-pointer-bubble.on, .of-pointer-ring.on { opacity: 1; }
.of-pointer-hand-inner { position: relative; color: #fbbf24;
  filter: drop-shadow(0 0 1px #1f2937) drop-shadow(0 0 1px #1f2937) drop-shadow(0 4px 6px rgba(0,0,0,.35)); }
.of-pointer-hand-inner.bob { animation: of-pointer-bob 1.1s ease-in-out infinite; }
.of-pointer-hand-inner.tap { animation: of-pointer-tap 420ms ease-in-out; }
.of-pointer-ripple { position: absolute; left: 13.6px; top: 0; width: 0; height: 0; border-radius: 9999px;
  border: 2px solid #f59e0b; transform: translate(-50%, -50%); animation: of-pointer-ripple 420ms ease-out forwards; }
.of-pointer-ring { border: 3px solid #f59e0b; border-radius: 10px; transition: transform 90ms linear, width 90ms linear, height 90ms linear, opacity 200ms ease;
  box-shadow: 0 0 0 0 rgba(245,158,11,.55); }
.of-pointer-ring.on { animation: of-pointer-glow 1.4s ease-out infinite; }
.of-pointer-bubble { max-width: 240px; padding: 4px 8px; border-radius: 6px; font-size: 12px; line-height: 1.35;
  background: #111827; color: #fff; box-shadow: 0 4px 12px rgba(0,0,0,.25); transition: transform 90ms linear, opacity 200ms ease; }
.dark .of-pointer-bubble { background: #f9fafb; color: #111827; }
@keyframes of-pointer-bob { 0%, 100% { transform: translate(0, 0); } 50% { transform: translate(2px, 6px); } }
@keyframes of-pointer-tap { 0% { transform: scale(1); } 45% { transform: translate(0, 5px) scale(.86); } 100% { transform: scale(1); } }
@keyframes of-pointer-ripple { from { width: 0; height: 0; opacity: 1; } to { width: 44px; height: 44px; opacity: 0; } }
@keyframes of-pointer-glow { 0% { box-shadow: 0 0 0 0 rgba(245,158,11,.55); } 100% { box-shadow: 0 0 0 12px rgba(245,158,11,0); } }
@media (prefers-reduced-motion: reduce) {
  .of-pointer-hand.fly { transition: opacity 200ms ease; }
  .of-pointer-hand-inner.bob, .of-pointer-ring.on { animation: none; }
}

/* ── 사용 보류 노드 유형 (nodeCatalog.ON_HOLD_NODE_TYPES) — 툴박스 항목에 붙는 리본.
   막지 않는다: 이미 그 노드를 쓰는 워크플로·샘플이 있고 그대로 돌아야 한다. 새로 쓰지 말라는 표시다 */
.of-onhold { opacity: .62; }
.of-onhold:hover { opacity: .85; }
.of-onhold-ribbon { position: absolute; right: -16px; top: 9px; width: 52px; transform: rotate(45deg);
  background: #f59e0b; color: #fff; font-size: 8px; line-height: 12px; text-align: center;
  letter-spacing: -.06em; box-shadow: 0 1px 2px rgba(0,0,0,.25); pointer-events: none; }
/* 이름이 리본 아래로 들어가지 않게 자리를 비운다 */
.of-onhold > span:last-of-type { padding-right: 18px; }
.dark .of-onhold-ribbon { background: #b45309; }

/* ── 데이터처리의 예외 흐름 핸들 (utils/errorFlow) — 정상(성공) 핸들 조금 아래, 빨강.
   노드 높이가 56px 이라 가운데(50%)의 정상 핸들 아래 74% 지점에 둔다 */
/* 자리·크기는 인라인(utils/errorFlow.ERROR_HANDLE_STYLE)에서 정한다 — CSS 로 옮기면 React Flow 가 잰 자리와
   어긋나 선이 핸들 중앙에서 시작하지 않는다. 여기서는 색만 */
.react-flow__handle.error-handle { background: #fca5a5 !important; border: none !important; }
.react-flow__handle.error-handle:hover,
.react-flow__handle.error-handle.connectingfrom,
.react-flow__handle.error-handle.connectingto { background: #f87171 !important; }

/* 그룹(서브플로·반복그룹) 크기 조절 손잡이 — 작은 파란 네모 대신 모서리를 감싸는 ㄱ자 꺾쇠.
   잡는 자리가 모서리라는 것과 끌면 크기가 바뀐다는 것이 바로 보인다(현장 2026-10-01). 커서는 React Flow 가 대각선 화살표로 준다 */
.react-flow__resize-control.handle.of-resize-corner {
  /* 테두리와 겹치면 같은 파란색이라 묻힌다 — 바깥으로 조금 띄워 사진 자르기 표시처럼 보이게 */
  width: 20px; height: 20px; background: transparent; border: 0 solid #3772FF; border-radius: 2px;
  transition: width .1s, height .1s, border-color .1s;
}
.react-flow__resize-control.handle.of-resize-corner:hover { width: 26px; height: 26px; border-color: #1d4ed8; }
.dark .react-flow__resize-control.handle.of-resize-corner:hover { border-color: #93c5fd; }
.react-flow__resize-control.handle.of-resize-corner.top.left { border-top-width: 4px; border-left-width: 4px; transform: translate(-8px, -8px); }
.react-flow__resize-control.handle.of-resize-corner.top.right { border-top-width: 4px; border-right-width: 4px; transform: translate(calc(-100% + 8px), -8px); }
.react-flow__resize-control.handle.of-resize-corner.bottom.left { border-bottom-width: 4px; border-left-width: 4px; transform: translate(-8px, calc(-100% + 8px)); }
.react-flow__resize-control.handle.of-resize-corner.bottom.right { border-bottom-width: 4px; border-right-width: 4px; transform: translate(calc(-100% + 8px), calc(-100% + 8px)); }

/* 실행 중단 노드 — 흐리게 + 왼쪽 아래 주황 ⊠ (BaseNode, 테라스트림 Designer 의 실행 중단 표시와 같은 자리·색) */
.of-suspended { opacity: .55; border-style: dashed !important; }
.of-suspended-badge {
  position: absolute; left: -10px; bottom: -8px; z-index: 21; width: 18px; height: 18px; line-height: 16px; text-align: center;
  font-size: 14px; color: #fff; background: #f59e0b; border: 1px solid #d97706; border-radius: 3px; cursor: pointer; opacity: 1;
}
.first\\:mt-0:first-child {
  margin-top: 0px;
}
.last\\:border-0:last-child {
  border-width: 0px;
}
.last\\:border-b-0:last-child {
  border-bottom-width: 0px;
}
.hover\\:border-blue-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.hover\\:border-blue-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-blue-500) / var(--tw-border-opacity, 1));
}
.hover\\:border-gray-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-gray-300) / var(--tw-border-opacity, 1));
}
.hover\\:bg-amber-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-amber-100) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-blue-100) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-blue-200) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-blue-50) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-blue-600) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-blue-700) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-emerald-100) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-emerald-700) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-gray-100) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-gray-200) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-gray-300) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-gray-50) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-gray-700) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-gray-800) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-red-100) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-red-50) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-red-600) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-red-700) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-violet-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-violet-100) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-violet-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-violet-50) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-violet-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-violet-700) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-white) / var(--tw-bg-opacity, 1));
}
.hover\\:text-blue-600:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--c-blue-600) / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-700:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--c-blue-700) / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-800:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--c-blue-800) / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-600:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--c-gray-600) / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-700:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--c-gray-700) / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-800:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--c-gray-800) / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-900:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--c-gray-900) / var(--tw-text-opacity, 1));
}
.hover\\:text-red-500:hover {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-600:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--c-red-600) / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--c-white) / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:shadow-sm:hover {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:border-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-blue-500) / var(--tw-border-opacity, 1));
}
.focus\\:border-blue-400:focus {
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--c-blue-500) / var(--tw-ring-opacity, 1));
}
.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}
.disabled\\:border-gray-300:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-gray-300) / var(--tw-border-opacity, 1));
}
.disabled\\:bg-gray-100:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-gray-100) / var(--tw-bg-opacity, 1));
}
.disabled\\:bg-gray-300:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-gray-300) / var(--tw-bg-opacity, 1));
}
.disabled\\:bg-gray-50:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-gray-50) / var(--tw-bg-opacity, 1));
}
.disabled\\:text-gray-300:disabled {
  --tw-text-opacity: 1;
  color: rgb(var(--c-gray-300) / var(--tw-text-opacity, 1));
}
.disabled\\:text-gray-400:disabled {
  --tw-text-opacity: 1;
  color: rgb(var(--c-gray-400) / var(--tw-text-opacity, 1));
}
.disabled\\:text-gray-500:disabled {
  --tw-text-opacity: 1;
  color: rgb(var(--c-gray-500) / var(--tw-text-opacity, 1));
}
.disabled\\:opacity-30:disabled {
  opacity: 0.3;
}
.disabled\\:opacity-35:disabled {
  opacity: 0.35;
}
.disabled\\:opacity-40:disabled {
  opacity: 0.4;
}
.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}
.disabled\\:hover\\:bg-transparent:hover:disabled {
  background-color: transparent;
}
.group:hover .group-hover\\:flex {
  display: flex;
}
.group:hover .group-hover\\:text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-blue-700) / var(--tw-text-opacity, 1));
}
@media (min-width: 640px) {

  .sm\\:text-sm {
    font-size: 0.75rem;
    line-height: 1.125rem;
  }
}
@media (min-width: 768px) {

  .md\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
}
@media (min-width: 1024px) {

  .lg\\:w-1\\/3 {
    width: 33.333333%;
  }

  .lg\\:w-2\\/3 {
    width: 66.666667%;
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:flex-row {
    flex-direction: row;
  }
}
@media (min-width: 1280px) {

  .xl\\:inline {
    display: inline;
  }
}
.\\[\\&_svg\\]\\:h-5 svg {
  height: 1.25rem;
}
.\\[\\&_svg\\]\\:w-5 svg {
  width: 1.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,uCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,uCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,sEAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,uDAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,iCAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,gBAAc;EAAd,sBAAc;EAAd,kEAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,sBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,mBAAc;EAAd,sBAAc;AAAA;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,mEAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,iFAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,iBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,cAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,wCAAc;EAAd,4BAAc;EAAd,4BAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,wBAAc;EAAd,sBAAc;EAAd;AAAc;;AAAd;EAAA,gBAAc;EAAd,UAAc;EAAd,yBAAc;EAAd,qBAAc;EAAd,sBAAc;EAAd,6BAAc;EAAd,yBAAc;UAAd,iBAAc;EAAd,cAAc;EAAd,YAAc;EAAd,WAAc;EAAd,yDAAc;EAAd,sBAAc;EAAd,kEAAc;EAAd,iBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,mEAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd,8BAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;AAAA;;AAAd;;EAAA;IAAA;EAAc;AAAA;;AAAd;EAAA,yDAAc;AAAA;;AAAd;;EAAA;IAAA;EAAc;AAAA;;AAAd;EAAA,yBAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,yBAAc;EAAd,8BAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,4BAAc;AAAA;;AAAd;;EAAA;IAAA;EAAc;AAAA;;AAAd;EAAA,yBAAc;EAAd;AAAc;;AAAd;EAAA,iBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,gBAAc;EAAd,UAAc;EAAd,gBAAc;EAAd;AAAc;;AAAd;EAAA,6BAAc;EAAd;AAAc;EAAd;;;IAAA,kBAAc;IAAd,oBAAc;EAAA;AACd;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA,wBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;;;qEAGqE;;AAUrE;;;;;mEAKmE;AACnE;EACE,mBAAmB;EACnB,mFAAmF;EACnF,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;;EAExB,WAAW;EACX,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB;gFAC8E;EAC9E,sBAAsB,IAAI,wCAAwC;EAClE,qBAAqB,KAAK,wBAAwB;EAClD,qBAAqB,KAAK,qBAAqB;EAC/C,sBAAsB,IAAI,mBAAmB;EAC7C,sBAAsB,IAAI,kBAAkB;EAC5C,sBAAsB,IAAI,mBAAmB;EAC7C,yBAAyB,EAAE,iBAAiB;EAC5C,yBAAyB,EAAE,kBAAkB;EAC7C,yBAAyB;EACzB,yBAAyB,EAAE,qBAAqB;EAChD,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB,MAAM,oBAAoB;EAC/C,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB,IAAI,mBAAmB;EAC9C,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,0DAA0D;EAC1D,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;;EAE5B,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;;wDAEwD;AACxD;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,6BAA6B;EAC7B,sEAAsE;EACtE,kBAAkB;EAClB,qBAAqB;EACrB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;;EAEnB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;;EAEvB,oBAAoB;EACpB,yBAAyB,EAAE,UAAU;AACvC;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;;AAGA,0BAA0B;AAC1B;;;;;;;;;;EAUE,yBAAyB,EAAE,UAAU;EACrC,8BAA8B;AAChC;;AAEA,sBAAsB;AACtB;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,8EAA8E;AAC9E;;;EAGE,uBAAuB;EACvB,oCAA4B;UAA5B,4BAA4B;EAC5B;+DAC6D;EAC7D,6BAA6B;EAC7B,qBAAqB;EACrB,6BAA6B;EAC7B;;kEAEgE;EAChE,qBAAqB;EACrB,uBAAuB;EACvB,kCAAkC;EAClC,4BAA4B;EAC5B,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA,qFAAqF;;AAErF,mCAAmC;AACnC,2EAA2E;AAC3E,oCAAoC,UAAU,EAAE;;AAEhD;;EAEE,6BAA6B;EAC7B,oCAAoC;EACpC,mCAAmC;EACnC,8BAA8B;EAC9B,wBAAwB;EACxB,4BAA4B;EAC5B,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA,mCAAmC;AACnC;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA,qDAAqD;AACrD;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,iCAAiC;AACjC;;;EAGE,gCAAgC;EAChC,4BAA4B;EAC5B,2BAA2B,IAAI,kDAAkD;AACnF;;AAEA,2BAA2B;AAC3B;EACE,uBAAuB;EACvB,gCAAgC;EAChC,qDAAqD;AACvD;;AAEA,gDAAgD;AAChD;EACE,+BAA+B,IAAI,2CAA2C;AAChF;;AAEA,kDAAkD;AAClD;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;qEAEmE;EACnE,0BAA0B;EAC1B,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE;sEACoE;EACpE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,mBAAmB;EACnB,sBAAsB;AACxB;AACA;;mCAEmC,mBAAmB,EAAE;AACxD;yDACyD;AACzD,6CAA6C,UAAU,EAAE;AACzD,8CAA8C,WAAW,EAAE;AAC3D,4CAA4C,SAAS,EAAE;AACvD,+CAA+C,YAAY,EAAE;;AAE7D;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,sBAAsB;AACtB;;;EAGE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAGE;EAAA,kBAA+D;EAA/D,iBAA+D;EAA/D,sBAA+D;EAA/D,kEAA+D;EAA/D,kBAA+D;EAA/D,+DAA+D;EAA/D,gBAA+D;EAA/D,0CAA+D;EAA/D,uDAA+D;EAA/D;AAA+D;;AAA/D;EAAA,uCAA+D;AAAA;;AAI/D;EAAA,qBAA+D;EAA/D,wBAA+D;EAA/D,sBAA+D;EAA/D,kEAA+D;EAA/D,sBAA+D;EAA/D,kBAA+D;EAA/D,qBAA+D;EAA/D;AAA+D;;AAI/D;EAAA,oBAA4B;EAA5B,iBAA4B;EAA5B,oBAA4B;EAA5B;AAA4B;;AAI5B;EAAA,kBAA+E;EAA/E,UAA+E;EAA/E,QAA+E;EAA/E,YAA+E;EAA/E,YAA+E;EAA/E,sBAA+E;EAA/E,sBAA+E;EAA/E,kEAA+E;EAA/E,kBAA+E;EAA/E,+DAA+E;EAA/E;AAA+E;;AAA/E;EAAA,uCAA+E;AAAA;;AAI/E;EAAA,kBAA8E;EAA9E,SAA8E;EAA9E,QAA8E;EAA9E,YAA8E;EAA9E,YAA8E;EAA9E,uBAA8E;EAA9E,sBAA8E;EAA9E,kEAA8E;EAA9E,kBAA8E;EAA9E,+DAA8E;EAA9E;AAA8E;;AAA9E;EAAA,uCAA8E;AAAA;;AAGhF;sEACsE;;AAEtE,+CAA+C;AAC/C;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,iBAAiB;AACjB;;;EAGE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,WAAW;AACb;;AAEA,qBAAqB;AACrB;;;EAGE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,qBAAqB;EACrB,4BAA4B;EAC5B,sBAAsB,EAAE,cAAc;EACtC,wBAAwB;EACxB,0CAA0C;EAC1C,kBAAkB;EAClB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;4CAC4C;;AAE5C,0BAA0B;AAC1B;;;EAGE;;yEAEuE;EACvE,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;;;EAGE,2BAA2B;EAC3B,wEAAwE;EACxE,oDAAoD;EACpD,mDAAmD;EACnD,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA,8BAA8B;AAC9B;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;;mEAEmE;;AAEnE,kEAAkE;AAClE;EACE,uCAAuC;AACzC;AACA,6DAA6D;AAC7D,sBAAsB,8CAA8C,EAAE;AACtE,sBAAsB,6CAA6C,EAAE;AACrE,sBAAsB,6CAA6C,EAAE;AACrE,sBAAsB,8CAA8C,EAAE;AACtE,sBAAsB,6CAA6C,EAAE;AACrE,sBAAsB,6CAA6C,EAAE;AACrE,sBAAsB,6CAA6C,EAAE;AACrE;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;;AAEA,kEAAkE;AAClE;;;;;;;;;;;;;;;;EAgBE,uCAAuC;EACvC,oCAAoC;EACpC,6BAA6B;AAC/B;AACA;;EAEE,uCAAuC;EACvC,oCAAoC;AACtC;AACA;EACE,6BAA6B;AAC/B;;AAEA,+BAA+B;AAC/B;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,8CAA8C;EAC9C,oDAAoD;EACpD,mCAAmC;EACnC,yCAAyC;EACzC,0CAA0C;EAC1C,wDAAwD;EACxD,sCAAsC;EACtC,yDAAyD;EACzD,2CAA2C;EAC3C,2CAA2C;EAC3C,wDAAwD;EACxD,yCAAyC;EACzC,8BAA8B;EAC9B,+CAA+C;AACjD;AACA;iEACiE;AACjE;EACE,cAAc;AAChB;;AAEA,OAAO;AACP;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;;;;;;;;;;;EAaE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;;yCAEyC,mBAAmB,EAAE;;AAE9D,oEAAoE;AACpE;EACE,kDAAkD;EAClD,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,mDAAmD;AACrD;AACA;;;EAGE,2CAA2C;EAC3C,wCAAwC;AAC1C;;;AAGA,OAAO;AACP;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,sCAAsC;AACtC;;;EAGE,4DAA4D;EAC5D,+CAA+C;EAC/C,mCAAmC;AACrC;;AAEA,uCAAuC;AACvC;;;EAGE,uCAAuC;AACzC;;AAEA,0BAA0B;AAC1B,QAAQ,6BAA6B,EAAE;AACvC,4BAA4B,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE;AAC5E,kCAAkC,mBAAmB,EAAE;AACvD,kCAAkC,gBAAgB,EAAE,kBAAkB,EAAE,yBAAyB,EAAE;AACnG,wCAAwC,gBAAgB,EAAE;AAC1D,mCAAmC,mBAAmB,EAAE;;AAExD,+EAA+E;AAC/E,sBAAsB,WAAW,EAAE,iDAAiD,EAAE;AACtF,4BAA4B,WAAW,EAAE,2CAA2C,EAAE;;AAEtF,+CAA+C;AAC/C,kDAAkD,cAAc,EAAE;AAClE,wDAAwD,cAAc,EAAE;AACxE,oDAAoD,cAAc,EAAE;;AAEpE,4EAA4E;AAC5E;;;;;;EAME,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;;;EAGE,gBAAgB;AAClB;;AAEA;;uDAEuD;AACvD;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;AACA;;;EAGE,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA,mFAAmF,oCAAoC,EAAE;AACzH;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA,sDAAsD;AACtD;EACE,gBAAgB;AAClB;AACA;8DAC8D;;AAE9D,gEAAgE;AAChE;EACE,eAAe;EACf,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,yCAAyC;AAC3C;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB,aAAa,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AACzE,uBAAuB,6BAA6B,EAAE;;AAEtD;mEACmE;AACnE;;oCAEoC,2BAA2B,EAAE,uBAAuB,EAAE,4BAA4B,EAAE;AACxH,iFAAiF;AACjF;;;uCAGuC,wBAAwB,EAAE;AACjE;oDACoD,+CAA+C,EAAE;AACrG,uEAAuE;AACvE,+CAA+C,yBAAyB,EAAE;AAC1E,8CAA8C,yBAAyB,EAAE;AACzE,oBAAoB,cAAc,EAAE;AACpC,mBAAmB,cAAc,EAAE,oBAAoB,EAAE;AACzD,gCAAgC,cAAc,EAAE,YAAY,EAAE;AAC9D,mBAAmB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC/E,0BAA0B,cAAc,EAAE;AAC1C,yBAAyB,cAAc,EAAE;AACzC,sCAAsC,cAAc,EAAE;;AAEtD,mDAAmD;AACnD,+CAA+C;AAC/C,cAAc,kBAAkB,EAAE,SAAS,EAAE,UAAU,EAAE,WAAW,EAAE,cAAc,EAAE,YAAY,EAAE,kBAAkB;EACpH,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,WAAW,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;;AAE/G,aAAa,kBAAkB,EAAE,SAAS,EAAE,SAAS,EAAE,WAAW,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACrH,cAAc,EAAE,YAAY,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,WAAW,EAAE,mBAAmB,EAAE;AAC5I,sBAAsB,mBAAmB,EAAE;AAC3C,sBAAsB,mBAAmB,EAAE;AAC3C,sBAAsB,mBAAmB,EAAE;AAC3C,sBAAsB,mBAAmB,EAAE;AAC3C,sBAAsB,mBAAmB,EAAE;AAC3C,mBAAmB,UAAU,EAAE,WAAW,EAAE,sCAAsC,EAAE,sBAAsB,EAAE,kBAAkB,EAAE,uCAAuC,EAAE;AACzK,kBAAkB,gBAAgB,EAAE,iBAAiB,EAAE,4CAA4C,EAAE;AACrG,sBAAsB,KAAK,yBAAyB,EAAE,EAAE;AACxD,eAAe,YAAY,EAAE;AAC7B,eAAe,gCAAgC,EAAE,oDAAoD,EAAE;AACvG,eAAe,gCAAgC,EAAE;AACjD,eAAe,gCAAgC,EAAE,mDAAmD,EAAE;AACtG,eAAe,YAAY,EAAE,+BAA+B,EAAE;;AAE9D,qBAAqB;AACrB,gBAAgB,cAAc,EAAE,cAAc,EAAE,gBAAgB,EAAE,cAAc,EAAE;;AAElF,aAAa,eAAe,EAAE;;AAE9B,uDAAuD;AACvD,aAAa,kBAAkB,EAAE,QAAQ,EAAE,2BAA2B,EAAE,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE,eAAe;EACtI;sEACoE;EACpE,UAAU,EAAE,kBAAkB,EAAE,4DAA4D;EAC5F,wDAAwD;EACxD,eAAe,EAAE;AACnB,mBAAmB,WAAW,EAAE,2BAA2B,EAAE;AAC7D,oBAAoB,UAAU,EAAE;AAChC,wEAAwE;AACxE,oBAAoB,UAAU,EAAE,QAAQ,EAAE,8CAA8C,EAAE,6BAA6B,EAAE;AACzH,qCAAqC,yBAAyB,EAAE;AAChE,qCAAqC,qBAAqB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AACvG,2CAA2C,mBAAmB,EAAE,WAAW,EAAE;AAC7E,mBAAmB,WAAW,EAAE,SAAS,EAAE,6BAA6B,EAAE;AAC1E,mBAAmB,kBAAkB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,yBAAyB,EAAE,iCAAiC,EAAE,cAAc,EAAE,qBAAqB,EAAE,sBAAsB;EAC/M,YAAY,EAAE,IAAI,gEAAgE;AACpF,oDAAoD,WAAW,EAAE,kBAAkB,EAAE,SAAS,EAAE,QAAQ,EAAE,wBAAwB,EAAE,gCAAgC,EAAE,kBAAkB,EAAE;AAC1L,2BAA2B,WAAW,EAAE,WAAW,EAAE;AACrD,0BAA0B,UAAU,EAAE,YAAY,EAAE;AACpD,yBAAyB,mBAAmB,EAAE,WAAW,EAAE;AAC3D;sDACsD;AACtD,sCAAsC,kBAAkB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AACjG,4CAA4C,mBAAmB,EAAE,WAAW,EAAE;AAC9E,mBAAmB,kBAAkB,EAAE,WAAW,EAAE,YAAY,EAAE;AAClE;EACE,WAAW,EAAE,kBAAkB,EAAE,OAAO,EAAE,WAAW,EAAE,WAAW,EAAE,qBAAqB,EAAE,mBAAmB;AAChH;AACA,2BAA2B,QAAQ,EAAE,yBAAyB,EAAE,2BAA2B,EAAE;AAC7F,0BAA0B,WAAW,EAAE,yBAAyB,EAAE,8BAA8B,EAAE;;AAElG,iFAAiF;AACjF;wCACwC,UAAU,EAAE,mBAAmB,EAAE,wDAAwD,EAAE;AACnI,wFAAwF,UAAU,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC1I;;;;uDAIuD;AACvD,2DAA2D;AAC3D;4DAC4D;AAC5D,mKAAmK,UAAU,EAAE;AAC/K,4FAA4F,oBAAoB,EAAE;AAClH,0CAA0C,wBAAwB,EAAE;AACpE;oEACoE;AACpE;mDACmD,+BAA+B,EAAE;AACpF;sEACsE;AACtE,8DAA8D,UAAU,EAAE,kBAAkB,EAAE,4DAA4D,EAAE;AAC5J,sEAAsE;;AAEtE;sDACsD;AACtD,qBAAqB,WAAW,EAAE,kBAAkB,EAAE,UAAU,EAAE,WAAW,EAAE,SAAS,EAAE,YAAY,EAAE;AACxG,mEAAmE;AACnE,yCAAyC,2BAA2B,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AAC/G,uFAAuF;AACvF;6BAC6B,wBAAwB,EAAE;;AAEvD,yBAAyB;AACzB,oCAAoC,8BAA8B,EAAE,6BAA6B,EAAE;;AAEnG;;2DAE2D;AAC3D,iBAAiB,aAAa,EAAE,uBAAuB,EAAE,wCAAwC,EAAE;AACnG,sBAAsB,uBAAuB,EAAE;AAC/C,uBAAuB,gBAAgB,EAAE,aAAa,EAAE;AACxD,gBAAgB,oBAAoB,EAAE,8BAA8B,EAAE;AACtE,qBAAqB,wBAAwB,EAAE;AAC/C,0BAA0B;AAC1B,0BAA0B,uDAAuD,EAAE;;AAEnF;yCACyC;AACzC;EACE,uIAAuI;AACzI;AACA;EACE,8CAA8C;AAChD;;AAEA;;0DAE0D;AAC1D,mBAAmB,kBAAkB,EAAE;AACvC;;EAEE,WAAW,EAAE,kBAAkB,EAAE,MAAM,EAAE,SAAS,EAAE,UAAU;EAC9D,wBAAwB,EAAE,YAAY,EAAE,oBAAoB;AAC9D;AACA,2BAA2B,SAAS,EAAE;AACtC,0BAA0B,UAAU,EAAE;;AAEtC;;oEAEoE;AACpE;;;0BAG0B,wBAAwB,EAAE;AACpD,+DAA+D;AAC/D,iCAAiC,wBAAwB,EAAE;AAC3D,kCAAkC,oBAAoB,EAAE;AACxD,gCAAgC,eAAe,EAAE;;AAEjD;;;;;sBAKsB;AACtB,wCAAwC,YAAY,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,uCAAuC,EAAE;AAC5J,uDAAuD,gBAAgB,EAAE;AACzE,qDAAqD,wBAAmB,EAAnB,mBAAmB,EAAE;AAC1E;oEACoE,wBAAmB,EAAnB,mBAAmB,EAAE;AACzF,8CAA8C,0BAA0B,EAAE;;AAE1E;mEACmE;AACnE,oBAAoB,eAAe,EAAE,QAAQ,EAAE,oBAAoB,EAAE,cAAc,EAAE;AACrF,yDAAyD,kBAAkB,EAAE,OAAO,EAAE,MAAM,EAAE,UAAU,EAAE,sBAAsB,EAAE;AAClI,mBAAmB,qDAAqD,EAAE;AAC1E,4DAA4D;AAC5D,+CAA+C,0FAA0F,EAAE;AAC3I,kEAAkE,UAAU,EAAE;AAC9E,yBAAyB,kBAAkB,EAAE,cAAc;EACzD,wGAAwG,EAAE;AAC5G,6BAA6B,mDAAmD,EAAE;AAClF,6BAA6B,2CAA2C,EAAE;AAC1E,qBAAqB,kBAAkB,EAAE,YAAY,EAAE,MAAM,EAAE,QAAQ,EAAE,SAAS,EAAE,qBAAqB;EACvG,yBAAyB,EAAE,gCAAgC,EAAE,oDAAoD,EAAE;AACrH,mBAAmB,yBAAyB,EAAE,mBAAmB,EAAE,4FAA4F;EAC7J,wCAAwC,EAAE;AAC5C,sBAAsB,iDAAiD,EAAE;AACzE,qBAAqB,gBAAgB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,eAAe,EAAE,iBAAiB;EAC7G,mBAAmB,EAAE,WAAW,EAAE,sCAAsC,EAAE,qDAAqD,EAAE;AACnI,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;AAChE,4BAA4B,WAAW,0BAA0B,EAAE,EAAE,MAAM,8BAA8B,EAAE,EAAE;AAC7G,4BAA4B,KAAK,mBAAmB,EAAE,EAAE,MAAM,uCAAuC,EAAE,EAAE,OAAO,mBAAmB,EAAE,EAAE;AACvI,+BAA+B,OAAO,QAAQ,EAAE,SAAS,EAAE,UAAU,EAAE,EAAE,KAAK,WAAW,EAAE,YAAY,EAAE,UAAU,EAAE,EAAE;AACvH,6BAA6B,KAAK,wCAAwC,EAAE,EAAE,OAAO,yCAAyC,EAAE,EAAE;AAClI;EACE,uBAAuB,8BAA8B,EAAE;EACvD,kDAAkD,eAAe,EAAE;AACrE;;AAEA;8DAC8D;AAC9D,aAAa,YAAY,EAAE;AAC3B,mBAAmB,YAAY,EAAE;AACjC,oBAAoB,kBAAkB,EAAE,YAAY,EAAE,QAAQ,EAAE,WAAW,EAAE,wBAAwB;EACnG,mBAAmB,EAAE,WAAW,EAAE,cAAc,EAAE,iBAAiB,EAAE,kBAAkB;EACvF,sBAAsB,EAAE,qCAAqC,EAAE,oBAAoB,EAAE;AACvF,+BAA+B;AAC/B,iCAAiC,mBAAmB,EAAE;AACtD,0BAA0B,mBAAmB,EAAE;;AAE/C;iDACiD;AACjD;qCACqC;AACrC,mCAAmC,8BAA8B,EAAE,uBAAuB,EAAE;AAC5F;;gDAEgD,8BAA8B,EAAE;;AAEhF;uFACuF;AACvF;EACE,uDAAuD;EACvD,WAAW,EAAE,YAAY,EAAE,uBAAuB,EAAE,uBAAuB,EAAE,kBAAkB;EAC/F,mDAAmD;AACrD;AACA,4DAA4D,WAAW,EAAE,YAAY,EAAE,qBAAqB,EAAE;AAC9G,kEAAkE,qBAAqB,EAAE;AACzF,+DAA+D,qBAAqB,EAAE,sBAAsB,EAAE,gCAAgC,EAAE;AAChJ,gEAAgE,qBAAqB,EAAE,uBAAuB,EAAE,6CAA6C,EAAE;AAC/J,kEAAkE,wBAAwB,EAAE,sBAAsB,EAAE,6CAA6C,EAAE;AACnK,mEAAmE,wBAAwB,EAAE,uBAAuB,EAAE,0DAA0D,EAAE;;AAElL,+EAA+E;AAC/E,gBAAgB,YAAY,EAAE,+BAA+B,EAAE;AAC/D;EACE,kBAAkB,EAAE,WAAW,EAAE,YAAY,EAAE,WAAW,EAAE,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE,kBAAkB;EAC5H,eAAe,EAAE,WAAW,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,eAAe,EAAE,UAAU;AAC/H;AAt+BA;EAAA;AAu+BA;AAv+BA;EAAA;AAu+BA;AAv+BA;EAAA;AAu+BA;AAv+BA;EAAA,sBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,sBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,sBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,kBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,kBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,kBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,kBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,kBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,kBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,kBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,kBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,kBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,kBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,kBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,kBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,kBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,kBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,kBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,kBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,kBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,kBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,kBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,kBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,kBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,kBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,kBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,oBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,oBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,oBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,oBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,oBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,oBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,oBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,oBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,oBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,oBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA;AAu+BA;AAv+BA;EAAA,0CAu+BA;EAv+BA,uDAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,sBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,sBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,8BAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,2GAu+BA;EAv+BA,yGAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,oBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA;AAu+BA;AAv+BA;EAAA,sBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,kBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,kBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,kBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,oBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,oBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA,oBAu+BA;EAv+BA;AAu+BA;AAv+BA;EAAA;AAu+BA;AAv+BA;EAAA;AAu+BA;AAv+BA;EAAA;AAu+BA;AAv+BA;EAAA;AAu+BA;AAv+BA;EAAA;AAu+BA;AAv+BA;EAAA;AAu+BA;AAv+BA;EAAA,oBAu+BA;EAv+BA;AAu+BA;AAv+BA;;EAAA;IAAA,kBAu+BA;IAv+BA;EAu+BA;AAAA;AAv+BA;;EAAA;IAAA;EAu+BA;AAAA;AAv+BA;;EAAA;IAAA;EAu+BA;;EAv+BA;IAAA;EAu+BA;;EAv+BA;IAAA;EAu+BA;;EAv+BA;IAAA;EAu+BA;AAAA;AAv+BA;;EAAA;IAAA;EAu+BA;AAAA;AAv+BA;EAAA;AAu+BA;AAv+BA;EAAA;AAu+BA","sourcesContent":["@tailwind base;\r\n@tailwind components;\r\n@tailwind utilities;\r\n\r\n/* 입력란 글자 크기 — @tailwindcss/forms 는 글자 크기를 따로 주지 않은 입력란을 1rem(줄 높이 1.5rem)으로 만든다.\r\n   이 화면의 기본 글자는 0.75rem 이라, text-xs·text-sm 을 붙이지 않은 칸만 유독 크게 보였다(현장 2026-10-12:\r\n   실행 노드의 제한(초)·실행 전 대기·변수 값 칸 등 여기저기). 칸마다 고치지 않고, 크기를 주지 않은 입력란은\r\n   **둘레 글자 크기를 따르게** 한다. text-* 를 붙인 칸은 그대로다(유틸리티가 base 보다 뒤라 이긴다). */\r\n@layer base {\r\n  [type='text'], input:where(:not([type])), [type='email'], [type='url'], [type='password'], [type='number'],\r\n  [type='date'], [type='datetime-local'], [type='month'], [type='search'], [type='tel'], [type='time'], [type='week'],\r\n  [multiple], textarea, select {\r\n    font-size: inherit;\r\n    line-height: inherit;\r\n  }\r\n}\r\n\r\n/* ──────────────────────────────────────────────────────────────\r\n * 테마 팔레트\r\n * tailwind.config.js 가 white / gray-* / blue·red·amber 일부를 이 변수로 연결한다.\r\n * :root = 라이트(Tailwind 기본값 그대로), .dark = 다크(회색 스케일을 뒤집음).\r\n * 값은 \"R G B\" 공백 구분 — Tailwind 의 <alpha-value> 합성용.\r\n * ────────────────────────────────────────────────────────────── */\r\n:root {\r\n  color-scheme: light;\r\n  /* LiveSQL 라이트: bg #fff / #f5f6f8 / #e8ecf0, border #ddd, text #333 / #666 / #999 */\r\n  --c-white: 255 255 255;\r\n  --c-surface: 255 255 255;\r\n  --c-gray-50: 245 246 248;\r\n  --c-gray-100: 232 236 240;\r\n  --c-gray-200: 221 221 221;\r\n  --c-gray-300: 204 204 204;\r\n  --c-gray-400: 153 153 153;\r\n  --c-gray-500: 102 102 102;\r\n  --c-gray-600: 85 85 85;\r\n  --c-gray-700: 51 51 51;\r\n  --c-gray-800: 40 40 40;\r\n  --c-gray-900: 30 30 30;\r\n  --c-blue-50: 239 246 255;\r\n  --c-blue-100: 219 234 254;\r\n  --c-blue-200: 191 219 254;\r\n  --c-blue-500: 59 130 246;\r\n  --c-blue-600: 37 99 235;\r\n  --c-blue-700: 29 78 216;\r\n  --c-blue-800: 30 64 175;\r\n  --c-blue-900: 30 58 138;\r\n  --c-red-50: 254 242 242;\r\n  --c-red-100: 254 226 226;\r\n  --c-red-200: 254 202 202;\r\n  --c-red-600: 220 38 38;\r\n  --c-red-700: 185 28 28;\r\n  --c-red-800: 153 27 27;\r\n  --c-amber-50: 255 251 235;\r\n  --c-amber-100: 254 243 199;\r\n  --c-amber-200: 253 230 138;\r\n  --c-amber-300: 252 211 77;\r\n  --c-amber-500: 245 158 11;\r\n  --c-amber-600: 217 119 6;\r\n  --c-amber-700: 180 83 9;\r\n  --c-amber-800: 146 64 14;\r\n  --c-violet-50: 245 243 255;\r\n  --c-violet-100: 237 233 254;\r\n  --c-violet-300: 196 181 253;\r\n  --c-violet-400: 167 139 250;\r\n  --c-violet-600: 124 58 237;\r\n  --c-violet-700: 109 40 217;\r\n  --c-violet-800: 91 33 182;\r\n  --c-purple-500: 168 85 247;\r\n  --c-purple-800: 107 33 168;\r\n  --c-green-100: 220 252 231;\r\n  --c-green-400: 74 222 128;\r\n  --c-green-500: 34 197 94;\r\n  --c-green-600: 22 163 74;\r\n  --c-green-700: 21 128 61;\r\n  --c-green-800: 22 101 52;\r\n  --c-emerald-50: 236 253 245;\r\n  --c-emerald-100: 209 250 229;\r\n  --c-emerald-200: 167 243 208;\r\n  --c-emerald-300: 110 231 183;\r\n  --c-emerald-600: 5 150 105;\r\n  --c-emerald-700: 4 120 87;\r\n  --c-emerald-800: 6 95 70;\r\n\r\n  /* 캔버스 전용 */\r\n  --edge-stroke: #555;\r\n  --xy-background-pattern-dots-color: #bbb;\r\n}\r\n\r\n.dark {\r\n  color-scheme: dark;\r\n  /* LiveSQL 다크 = VS Code 팔레트: bg #1e1e1e / #252526 / #2d2d2d, border #404040,\r\n     text #d4d4d4 / #aaa / #777, accent #007acc, hover #37373d, active #094771 */\r\n  --c-white: 255 255 255;   /* text-white 는 흰색 유지, 표면은 --c-surface */\r\n  --c-surface: 37 37 38;    /* 카드·패널·입력창 (#252526) */\r\n  --c-gray-50: 30 30 30;    /* 페이지 바닥 (#1e1e1e) */\r\n  --c-gray-100: 45 45 45;   /* 탭·헤더 (#2d2d2d) */\r\n  --c-gray-200: 64 64 64;   /* 경계선 (#404040) */\r\n  --c-gray-300: 85 85 85;   /* 입력창 테두리 (#555) */\r\n  --c-gray-400: 119 119 119; /* muted (#777) */\r\n  --c-gray-500: 170 170 170; /* 보조 텍스트 (#aaa) */\r\n  --c-gray-600: 200 200 200;\r\n  --c-gray-700: 212 212 212; /* 본문 텍스트 (#d4d4d4) */\r\n  --c-gray-800: 230 230 230;\r\n  --c-gray-900: 240 240 240;\r\n  --c-blue-50: 9 71 113;     /* 선택 배경 (#094771) */\r\n  --c-blue-100: 26 58 92;\r\n  --c-blue-200: 38 79 120;\r\n  --c-blue-500: 0 122 204;   /* accent #007acc */\r\n  --c-blue-600: 0 98 163;\r\n  --c-blue-700: 108 182 255;\r\n  --c-blue-800: 160 205 255;\r\n  --c-blue-900: 200 225 255;\r\n  --c-red-50: 74 21 27;\r\n  --c-red-100: 90 30 32;\r\n  --c-red-200: 122 34 40;\r\n  --c-red-600: 229 115 115;\r\n  --c-red-700: 255 138 128;\r\n  --c-red-800: 255 170 160;\r\n  --c-amber-50: 50 36 8;\r\n  --c-amber-100: 69 44 3;\r\n  --c-amber-200: 100 66 10;\r\n  --c-amber-300: 160 100 20;\r\n  --c-amber-500: 245 158 11;\r\n  --c-amber-600: 251 191 36;\r\n  --c-amber-700: 252 211 77;\r\n  --c-amber-800: 255 213 79;\r\n  /* AI 패널(violet)·성공/적합(green, emerald) — 어두운 틴트 + 밝은 텍스트 */\r\n  --c-violet-50: 46 36 74;\r\n  --c-violet-100: 58 45 96;\r\n  --c-violet-300: 110 86 170;\r\n  --c-violet-400: 139 116 200;\r\n  --c-violet-600: 167 139 250;\r\n  --c-violet-700: 196 181 253;\r\n  --c-violet-800: 221 214 254;\r\n  --c-purple-500: 192 132 252;\r\n  --c-purple-800: 233 213 255;\r\n  --c-green-100: 20 60 36;\r\n  --c-green-400: 74 222 128;\r\n  --c-green-500: 52 199 110;\r\n  --c-green-600: 110 231 160;\r\n  --c-green-700: 134 239 172;\r\n  --c-green-800: 187 247 208;\r\n  --c-emerald-50: 16 48 40;\r\n  --c-emerald-100: 22 64 52;\r\n  --c-emerald-200: 30 90 72;\r\n  --c-emerald-300: 52 140 110;\r\n  --c-emerald-600: 52 211 153;\r\n  --c-emerald-700: 110 231 183;\r\n  --c-emerald-800: 167 243 208;\r\n\r\n  --edge-stroke: #9a9a9a;\r\n  --xy-background-pattern-dots-color: #3a3a3a;\r\n}\r\n\r\n@keyframes flow {\r\n  from {\r\n    stroke-dashoffset: 10;\r\n  }\r\n  to {\r\n    stroke-dashoffset: 0;\r\n  }\r\n}\r\n\r\n/* 전역 배율 — 오픈데이터모델러와 같은 90%. rem 으로 쓴 글자·여백·아이콘이 함께 줄어든다.\r\n   글자 크기는 tailwind.config.js 와 이 파일에서 rem 으로 쓴다(px 로 쓰면 배율을 따라가지 않는다).\r\n   캔버스 도형(노드 150×80, 핸들 등)은 캔버스 확대/축소를 따르므로 px 그대로 둔다. */\r\nhtml {\r\n  font-size: 90%;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  background-color: rgb(var(--c-gray-50));\r\n  color: rgb(var(--c-gray-900));\r\n  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;\r\n  font-size: 0.75rem;\r\n  line-height: 1.125rem;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n.react-flow__node {\r\n  padding: 10px;\r\n  border-radius: 3px;\r\n  width: 205px;\r\n  font-size: 12px;\r\n  color: #222;\r\n  text-align: center;\r\n  border-width: 1px;\r\n  border-style: solid;\r\n\r\n  /* 하위 요소들을 중앙 정렬하기 위한 속성 추가 */\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;  \r\n\r\n  /* 배경색을 밝은 회색으로 설정 */\r\n  background-color: #f0f0f0; /* 밝은 회색 */  \r\n}\r\n\r\n.react-flow__node-input {\r\n  background: #fff;\r\n  border-color: #0041d0;\r\n}\r\n\r\n.react-flow__node-output {\r\n  background: #fff;\r\n  border-color: #ff0072;\r\n}\r\n\r\n.react-flow__node-default {\r\n  background: #fff;\r\n  border-color: #1a192b;\r\n}\r\n\r\n\r\n/* 프로세스, 컨트롤 노드들에 대한 스타일 */\r\n.react-flow__node-filter,\r\n.react-flow__node-join,\r\n.react-flow__node-dbExtract,\r\n.react-flow__node-csvExtract,\r\n.react-flow__node-dbLoad,\r\n.react-flow__node-csvLoad,\r\n.react-flow__node-processLoad,\r\n.react-flow__node-branch,\r\n.react-flow__node-merge,\r\n.react-flow__node-userConfirm {\r\n  background-color: #f0f0f0; /* 밝은 회색 */  \r\n  border-radius: 42px !important;\r\n}\r\n\r\n/* 컨트롤 노드 타입별 테두리 색상 */\r\n.react-flow__node-branch {\r\n  border-color: #ff9800 !important;\r\n}\r\n\r\n.react-flow__node-merge {\r\n  border-color: #2196f3 !important;\r\n}\r\n\r\n.react-flow__node-userConfirm {\r\n  border-color: #9c27b0 !important;\r\n}\r\n\r\n/* Group Node Base Styles - high specificity to override React Flow defaults */\r\n.react-flow__node.react-flow__node-group,\r\n.react-flow__node.react-flow__node-subflow,\r\n.react-flow__node.react-flow__node-repeatGroup {\r\n  cursor: grab !important;\r\n  user-select: none !important;\r\n  /* React Flow 노드는 모두 absolute — relative 로 두면 그룹이 노드 레이어의 일반 흐름을 차지해\r\n     DOM 상 뒤에 오는 노드들(top:auto)이 그룹 높이만큼 아래로 밀려 자식이 그룹 밖에 그려졌다 */\r\n  position: absolute !important;\r\n  z-index: 0 !important;\r\n  border-radius: 8px !important;\r\n  /* 래퍼는 도형을 그리지 않는다 — 테두리·배경·패딩은 BaseGroupNode(.group-node) 하나가 담당.\r\n     (예전엔 래퍼 1px 테두리+30px 패딩 안에 또 하나의 박스가 있어 외곽선이 2겹으로 보였다.\r\n      패딩을 없애면 자식 좌표(부모 원점 기준)와 박스 원점이 일치해 자동 배치/자동 크기 계산도 단순해진다) */\r\n  padding: 0 !important;\r\n  border: none !important;\r\n  background: transparent !important;\r\n  overflow: visible !important;\r\n  box-sizing: border-box !important;\r\n  transform-origin: top left !important;\r\n}\r\n\r\n/* 그룹 크기는 노드 style(width/height) 이 정한다 — 자동(자식에 맞춤)/수동(리사이저) 모드. 고정 크기 CSS 는 두지 않는다 */\r\n\r\n/* Group node content area styles */\r\n/* 그룹의 연결점은 안쪽 영역(.group-content, z-index 1) 위에 — 아래쪽 점의 윗부분이 안쪽 영역에 가려졌다 */\r\n.group-node > .react-flow__handle { z-index: 2; }\r\n\r\n.group-content,\r\ndiv[data-content-for] {\r\n  position: relative !important;\r\n  height: calc(100% - 40px) !important;\r\n  width: calc(100% - 20px) !important;\r\n  margin: 10px auto 0 !important;\r\n  padding: 10px !important;\r\n  overflow: visible !important;\r\n  box-sizing: border-box !important;\r\n  z-index: 1 !important;\r\n}\r\n\r\n/* Parent-child positioning fixes */\r\n.react-flow__node[data-parent-id] {\r\n  z-index: 10 !important;\r\n  position: absolute !important;\r\n}\r\n\r\n/* Debug borders for visual guidance in development */\r\n.react-flow__node[data-dev-mode=\"true\"] {\r\n  outline: 2px dashed rgba(255, 0, 0, 0.3);\r\n}\r\n\r\n.react-flow__node[data-dev-mode=\"true\"] .group-content {\r\n  outline: 2px dashed rgba(0, 0, 255, 0.3);\r\n}\r\n\r\n/* Selected group nodes styling */\r\n.react-flow__node-group.selected,\r\n.react-flow__node-subflow.selected,\r\n.react-flow__node-repeatGroup.selected {\r\n  border-color: #3772FF !important;\r\n  border-width: 2px !important;\r\n  box-shadow: none !important;   /* 테두리(.group-node 2px) 하나로 — 바깥 번짐까지 겹쳐 두꺼워 보였다 */\r\n}\r\n\r\n/* Dragging state styling */\r\n.react-flow__node[data-dragging=\"true\"] {\r\n  opacity: 0.8 !important;\r\n  border-color: #ff9900 !important;\r\n  box-shadow: 0 0 8px rgba(255, 153, 0, 0.5) !important;\r\n}\r\n\r\n/* Fix for child nodes when parent is dragging */\r\n.react-flow__node[data-parent-dragging=\"true\"] {\r\n  pointer-events: none !important;   /* 흐리게·뒤로 보내지 않는다 — 그룹을 끄는 동안 안쪽이 가려져 보였다 */\r\n}\r\n\r\n/* Positioning grid for visualization (dev only) */\r\n.react-flow__node[data-dev-mode=\"true\"]::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-image: \r\n    linear-gradient(to right, rgba(0,0,0,0.05) 1px, transparent 1px),\r\n    linear-gradient(to bottom, rgba(0,0,0,0.05) 1px, transparent 1px);\r\n  background-size: 20px 20px;\r\n  pointer-events: none;\r\n  z-index: 0;\r\n}\r\n\r\n.react-flow__handle {\r\n  /* 연결을 시작하는 자리라 **손으로 맞출 수 있을 만큼** 커야 한다 — 8px 은 조준이 어려웠다(현장 2026-09-22).\r\n     노드가 쓰는 w-4/h-4 는 React Flow 기본값과 같은 자리라 이 규칙이 이긴다. 여기서 크기를 정한다. */\r\n  width: 14px;\r\n  height: 14px;\r\n  /* 회색 — 노드 내용보다 눈에 띄지 않게. 연결할 때만 강조된다(아래 :hover·connecting) */\r\n  background: #9ca3af;\r\n  border: 2px solid #fff;\r\n}\r\n.react-flow__handle:hover,\r\n.react-flow__handle.connectingfrom,\r\n.react-flow__handle.connectingto { background: #6b7280; }\r\n/* 핸들 중심을 **테두리 선 위**에 둔다. React Flow 는 노드의 안쪽 면(테두리 안)을 0 으로 잡아서,\r\n   노드 테두리(2px)만큼 핸들이 안으로 들어와 보였다. 테두리 두께의 절반만큼 바깥으로 민다. */\r\n.react-flow__node .react-flow__handle-left { left: -1px; }\r\n.react-flow__node .react-flow__handle-right { right: -1px; }\r\n.react-flow__node .react-flow__handle-top { top: -1px; }\r\n.react-flow__node .react-flow__handle-bottom { bottom: -1px; }\r\n\r\n.react-flow__edge-path {\r\n  stroke: #374151;\r\n  stroke-width: 2;\r\n  z-index: 11 !important;\r\n}\r\n\r\n.react-flow__edge-path-selector {\r\n  stroke: transparent;\r\n  stroke-width: 10;\r\n  cursor: pointer;\r\n}\r\n\r\n.react-flow__edge.selected .react-flow__edge-path {\r\n  stroke: #3b82f6;\r\n}\r\n\r\n.react-flow__node.selected {\r\n  box-shadow: 0 0 0 2px #784be8;\r\n}\r\n\r\n/* 그룹 노드 선택 시 특별 스타일 */\r\n.react-flow__node-group.selected,\r\n.react-flow__node-subflow.selected,\r\n.react-flow__node-repeatGroup.selected {\r\n  box-shadow: 0 0 0 3px #784be8;\r\n  z-index: 5 !important;\r\n}\r\n\r\n.workflow-node {\r\n  @apply bg-white border border-gray-200 rounded-lg p-3 shadow-sm;\r\n}\r\n\r\n.workflow-node-header {\r\n  @apply border-b border-gray-100 pb-2 mb-2 font-semibold text-sm;\r\n}\r\n\r\n.workflow-node-content {\r\n  @apply text-xs text-gray-600;\r\n}\r\n\r\n.property-panel {\r\n  @apply absolute right-0 top-0 w-72 h-full bg-white border-l border-gray-200 p-4;\r\n}\r\n\r\n.toolbox-panel {\r\n  @apply absolute left-0 top-0 w-48 h-full bg-white border-r border-gray-200 p-4;\r\n}\r\n\r\n/* 주의: .react-flow__renderer 에 배경색을 주지 말 것 — z-index 4 라 Background 점 패턴과 워크플로명 워터마크를 가린다.\r\n   캔버스 바닥색은 --xy-background-color(라이트 기본 흰색, 다크는 아래 .dark 블록)가 담당한다. */\r\n\r\n/* Add gradient definition for animated edges */\r\n.react-flow__renderer svg defs {\r\n  position: absolute;\r\n}\r\n\r\n.react-flow__renderer svg defs linearGradient#animated-edge-gradient {\r\n  --color-start: #374151;\r\n  --color-stop: #9ca3af;\r\n}\r\n\r\n.react-flow__renderer svg defs linearGradient#animated-edge-gradient stop:first-child {\r\n  stop-color: var(--color-start);\r\n}\r\n\r\n.react-flow__renderer svg defs linearGradient#animated-edge-gradient stop:last-child {\r\n  stop-color: var(--color-stop);\r\n}\r\n\r\n/* 그룹 노드 헤더 스타일 */\r\n.react-flow__node-group .group-node-header,\r\n.react-flow__node-subflow .group-node-header,\r\n.react-flow__node-repeatGroup .group-node-header {\r\n  position: absolute;\r\n  top: 8px;\r\n  left: 12px;\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  width: calc(100% - 24px);\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  pointer-events: none;\r\n  z-index: 10;\r\n}\r\n\r\n/* 그룹 노드 콘텐츠 영역 스타일 */\r\n.react-flow__node-group .group-node-content,\r\n.react-flow__node-subflow .group-node-content,\r\n.react-flow__node-repeatGroup .group-node-content {\r\n  position: relative;\r\n  width: 100%;\r\n  height: calc(100% - 30px);\r\n  margin-top: 20px;\r\n  z-index: 1;\r\n  /* 명확한 내부 패딩 설정 */\r\n  padding: 10px;\r\n  /* 명확한 포지셔닝 컨텍스트 생성 */\r\n  transform-style: preserve-3d;\r\n  box-sizing: border-box; /* 명시적 크기 계산 */\r\n  /* 자식 노드 영역 표시를 위한 스타일 */\r\n  background-color: rgba(255, 255, 255, 0.2);\r\n  border-radius: 4px;\r\n  /* 디버깅: 콘텐츠 영역 시각화 */\r\n  outline: 1px dashed rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n/* 예전 디버깅용 표시(왼쪽 위 파란 점, 아래 가운데 크기 글상자)는 뺐다 — 사용자에게 뜻 없는 점이 보이고\r\n   아래 글상자는 아래쪽 연결점 윗부분을 가렸다(현장 2026-10-01) */\r\n\r\n/* 개발 모드에서만 표시되는 디버깅 그리드 */\r\n.react-flow__renderer[data-dev-mode=\"true\"] .react-flow__node-group .group-node-content,\r\n.react-flow__renderer[data-dev-mode=\"true\"] .react-flow__node-subflow .group-node-content,\r\n.react-flow__renderer[data-dev-mode=\"true\"] .react-flow__node-repeatGroup .group-node-content {\r\n  background-image: \r\n    linear-gradient(to right, rgba(0, 0, 255, 0.1) 1px, transparent 1px),\r\n    linear-gradient(to bottom, rgba(0, 0, 255, 0.1) 1px, transparent 1px);\r\n  background-size: 20px 20px;\r\n}\r\n\r\n/* 그룹 노드 드래그 중 스타일 */\r\n.react-flow__node-group.dragging,\r\n.react-flow__node-subflow.dragging,\r\n.react-flow__node-repeatGroup.dragging {\r\n  cursor: grabbing !important;\r\n  /* z-index 를 올리지 않고 배경도 칠하지 않는다 — 그룹 상자가 안의 노드·연결선을 덮었다(현장 2026-10-01) */\r\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2) !important;\r\n  border: 2px solid rgba(0, 122, 255, 0.5) !important;\r\n  will-change: transform !important;\r\n  transition: box-shadow 0.2s ease !important;\r\n}\r\n\r\n/* 부모 노드가 드래그 중일 때 자식 노드 스타일 */\r\n.react-flow__node[data-parent-dragging=\"true\"] {\r\n  pointer-events: none !important;\r\n  box-shadow: none !important;\r\n} \r\n/* ──────────────────────────────────────────────────────────────\r\n * 다크 테마 — Tailwind 클래스가 아닌 고정 색상(캔버스·폼·인라인 스타일) 보정\r\n * ────────────────────────────────────────────────────────────── */\r\n\r\n/* 표면: bg-white 만 어두운 표면색으로 (text-white / border-white 는 그대로 흰색) */\r\n.dark .bg-white {\r\n  background-color: rgb(var(--c-surface));\r\n}\r\n/* 투명도 변형 (bg-white/90 등) — Tailwind 가 별도 클래스로 생성하므로 각각 덮는다 */\r\n.dark .bg-white\\/95 { background-color: rgb(var(--c-surface) / 0.95); }\r\n.dark .bg-white\\/90 { background-color: rgb(var(--c-surface) / 0.9); }\r\n.dark .bg-white\\/80 { background-color: rgb(var(--c-surface) / 0.8); }\r\n.dark .bg-white\\/75 { background-color: rgb(var(--c-surface) / 0.75); }\r\n.dark .bg-white\\/70 { background-color: rgb(var(--c-surface) / 0.7); }\r\n.dark .bg-white\\/60 { background-color: rgb(var(--c-surface) / 0.6); }\r\n.dark .bg-white\\/50 { background-color: rgb(var(--c-surface) / 0.5); }\r\n.dark .hover\\:bg-white:hover {\r\n  background-color: rgb(var(--c-surface));\r\n}\r\n.dark .focus\\:bg-white:focus {\r\n  background-color: rgb(var(--c-surface));\r\n}\r\n\r\n/* 폼 컨트롤 (@tailwindcss/forms 가 base 레이어에서 흰 배경을 박아 넣으므로 여기서 덮는다) */\r\n.dark input:not([type]),\r\n.dark [type='text'],\r\n.dark [type='email'],\r\n.dark [type='url'],\r\n.dark [type='password'],\r\n.dark [type='number'],\r\n.dark [type='date'],\r\n.dark [type='datetime-local'],\r\n.dark [type='month'],\r\n.dark [type='search'],\r\n.dark [type='tel'],\r\n.dark [type='time'],\r\n.dark [type='week'],\r\n.dark [multiple],\r\n.dark textarea,\r\n.dark select {\r\n  background-color: rgb(var(--c-surface));\r\n  border-color: rgb(var(--c-gray-300));\r\n  color: rgb(var(--c-gray-800));\r\n}\r\n.dark [type='checkbox'],\r\n.dark [type='radio'] {\r\n  background-color: rgb(var(--c-surface));\r\n  border-color: rgb(var(--c-gray-400));\r\n}\r\n.dark ::placeholder {\r\n  color: rgb(var(--c-gray-400));\r\n}\r\n\r\n/* React Flow 크롬 (v12 CSS 변수) */\r\n.dark .react-flow {\r\n  --xy-background-color: #1e1e1e;\r\n  --xy-node-color: #d4d4d4;\r\n  --xy-controls-button-background-color: #252526;\r\n  --xy-controls-button-background-color-hover: #3a3a3a;\r\n  --xy-controls-button-color: #d4d4d4;\r\n  --xy-controls-button-color-hover: #ffffff;\r\n  --xy-controls-button-border-color: #3a3a3a;\r\n  --xy-controls-box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.4);\r\n  --xy-minimap-background-color: #252526;\r\n  --xy-minimap-mask-background-color: rgba(30, 30, 30, 0.7);\r\n  --xy-minimap-node-background-color: #404040;\r\n  --xy-minimap-node-stroke-color: transparent;\r\n  --xy-attribution-background-color: rgba(30, 30, 30, 0.6);\r\n  --xy-edge-label-background-color: #252526;\r\n  --xy-edge-label-color: #d4d4d4;\r\n  --xy-node-boxshadow-selected: 0 0 0 2px #784be8;\r\n}\r\n/* .react-flow__renderer 에 불투명 배경을 주지 않는다 — z-index 4 라 Background 점 패턴과 워터마크(z 0)를 덮어 버린다.\r\n   캔버스 바닥색은 위의 --xy-background-color 가 이미 담당한다 (2026-09-05 실측). */\r\n.dark .react-flow__attribution a {\r\n  color: #9a9a9a;\r\n}\r\n\r\n/* 노드 */\r\n.dark .react-flow__node {\r\n  color: #d4d4d4;\r\n  background-color: #252526;\r\n  border-color: #404040;\r\n}\r\n.dark .react-flow__node-input,\r\n.dark .react-flow__node-output,\r\n.dark .react-flow__node-default,\r\n.dark .react-flow__node-filter,\r\n.dark .react-flow__node-join,\r\n.dark .react-flow__node-dbExtract,\r\n.dark .react-flow__node-csvExtract,\r\n.dark .react-flow__node-dbLoad,\r\n.dark .react-flow__node-csvLoad,\r\n.dark .react-flow__node-processLoad,\r\n.dark .react-flow__node-branch,\r\n.dark .react-flow__node-merge,\r\n.dark .react-flow__node-userConfirm {\r\n  background-color: #252526;\r\n}\r\n.dark .react-flow__node-default {\r\n  border-color: #555555;\r\n}\r\n.dark .react-flow__handle {\r\n  background: #6b7280;\r\n  border-color: #1e1e1e;\r\n}\r\n.dark .react-flow__handle:hover,\r\n.dark .react-flow__handle.connectingfrom,\r\n.dark .react-flow__handle.connectingto { background: #9ca3af; }\r\n\r\n/* 그룹 노드 — BaseGroupNode 가 인라인 style 로 밝은 배경을 주므로 !important 로 덮는다 */\r\n.dark .group-node {\r\n  background-color: rgb(var(--c-surface)) !important;\r\n  border-color: #404040 !important;\r\n}\r\n.dark .group-node.subflow-node {\r\n  border-color: #2f7f6a !important;\r\n}\r\n.dark .group-node.repeatGroup-node {\r\n  border-color: #8a5a5a !important;\r\n}\r\n.dark .group-node.selected {\r\n  border-color: #3772FF !important;\r\n}\r\n.dark .group-header {\r\n  background-color: #3a3a3a !important;\r\n  color: #d4d4d4 !important;\r\n}\r\n.dark .subflow-node .group-header {\r\n  background-color: #2f5f55 !important;\r\n}\r\n.dark .repeatGroup-node .group-header {\r\n  background-color: #5f3f3f !important;\r\n}\r\n.dark .group-content {\r\n  background-color: transparent !important;\r\n}\r\n.dark .node-toolbar {\r\n  background-color: #252526 !important;\r\n  color: #d4d4d4 !important;\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5) !important;\r\n}\r\n.dark .react-flow__node-group .group-node-content,\r\n.dark .react-flow__node-subflow .group-node-content,\r\n.dark .react-flow__node-repeatGroup .group-node-content {\r\n  background-color: rgba(255, 255, 255, 0.04);\r\n  outline-color: rgba(255, 255, 255, 0.15);\r\n}\r\n\r\n\r\n/* 엣지 */\r\n.dark .react-flow__edge.selected .react-flow__edge-path {\r\n  stroke: #3794ff;\r\n}\r\n.dark .react-flow__renderer svg defs linearGradient#animated-edge-gradient {\r\n  --color-start: #9a9a9a;\r\n  --color-stop: #404040;\r\n}\r\n\r\n/* Chromium 자동완성이 입력창을 흰색으로 칠하는 것 방지 */\r\n.dark input:-webkit-autofill,\r\n.dark input:-webkit-autofill:hover,\r\n.dark input:-webkit-autofill:focus {\r\n  -webkit-box-shadow: 0 0 0 1000px rgb(var(--c-surface)) inset;\r\n  -webkit-text-fill-color: rgb(var(--c-gray-800));\r\n  caret-color: rgb(var(--c-gray-800));\r\n}\r\n\r\n/* 포커스 시에도 표면색 유지 (브라우저 기본 포커스 배경 방지) */\r\n.dark input:focus,\r\n.dark textarea:focus,\r\n.dark select:focus {\r\n  background-color: rgb(var(--c-surface));\r\n}\r\n\r\n/* 스크롤바 (LiveSQL 다크와 동일) */\r\n.dark { scrollbar-color: #555 #1e1e1e; }\r\n.dark ::-webkit-scrollbar { background: #1e1e1e; width: 12px; height: 12px; }\r\n.dark ::-webkit-scrollbar-track { background: #1e1e1e; }\r\n.dark ::-webkit-scrollbar-thumb { background: #555; border-radius: 4px; border: 2px solid #1e1e1e; }\r\n.dark ::-webkit-scrollbar-thumb:hover { background: #666; }\r\n.dark ::-webkit-scrollbar-corner { background: #1e1e1e; }\r\n\r\n/* 워크플로명 워터마크 (WorkflowCanvas) — 배경 위, 노드 아래. 라이트는 연회색+흰 그림자, 다크는 중간회색+검은 그림자 */\r\n.workflow-watermark { color: #ccc; text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.5); }\r\n.dark .workflow-watermark { color: #777; text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5); }\r\n\r\n/* 캔버스 배율 자동/수동 토글 버튼 (React Flow Controls 안) */\r\n.react-flow__controls-button.zoom-mode-auto svg { color: #3b82f6; }\r\n.dark .react-flow__controls-button.zoom-mode-auto svg { color: #3794ff; }\r\n.react-flow__controls-button.zoom-mode-manual svg { color: #f59e0b; }\r\n\r\n/* ── 속성 패널(RJSF) 폼 컨트롤 글꼴 통일 — 브라우저 기본(13.33px, 시스템 폰트)이 아니라 UI 글꼴 12px 로 */\r\n.rjsf,\r\n.rjsf input,\r\n.rjsf select,\r\n.rjsf textarea,\r\n.rjsf button,\r\n.rjsf label {\r\n  font-family: inherit;\r\n  font-size: 0.75rem;\r\n  line-height: 1.125rem;\r\n}\r\n.rjsf input:not([type='checkbox']):not([type='radio']),\r\n.rjsf select,\r\n.rjsf textarea {\r\n  padding: 4px 8px;\r\n}\r\n\r\n/* ── 일반 노드의 React Flow 래퍼는 도형을 그리지 않는다 — 노드 컴포넌트(BaseNode) 하나가 단일 도형.\r\n   (예전엔 래퍼가 205px 회색 사각형/알약 + 내부 150×80 둥근 사각형으로 2중 테두리처럼 보였다)\r\n   그룹 노드(group/subflow/repeatGroup)는 래퍼가 컨테이너 역할이라 제외 */\r\n.react-flow__node:not(.react-flow__node-group):not(.react-flow__node-subflow):not(.react-flow__node-repeatGroup) {\r\n  padding: 0;\r\n  width: auto;\r\n  border: none;\r\n  background: transparent;\r\n  border-radius: 0;\r\n}\r\n.react-flow__node-filter, .react-flow__node-join, .react-flow__node-dbExtract, .react-flow__node-csvExtract,\r\n.react-flow__node-dbLoad, .react-flow__node-csvLoad, .react-flow__node-processLoad,\r\n.react-flow__node-branch, .react-flow__node-merge, .react-flow__node-userConfirm {\r\n  background-color: transparent;\r\n  border-radius: 0 !important;\r\n}\r\n.react-flow__node-branch, .react-flow__node-merge, .react-flow__node-userConfirm { border-color: transparent !important; }\r\n.dark .react-flow__node {\r\n  background-color: transparent;\r\n  border-color: transparent;\r\n}\r\n/* 선택 강조는 래퍼가 아니라 도형에 — 래퍼는 도형과 같은 크기이므로 둥근 모서리만 맞춘다 */\r\n.react-flow__node.selected:not(.react-flow__node-group):not(.react-flow__node-subflow):not(.react-flow__node-repeatGroup) {\r\n  box-shadow: none;\r\n}\r\n/* 도형 자체의 파란 테두리(BaseNode border-blue-500, 2px)만으로 선택을 보인다 —\r\n   예전엔 그 바깥에 보라색 2px 를 하나 더 둘러 4px 두 겹으로 두꺼웠다(현장 2026-10-01) */\r\n\r\n/* ── 전역 툴팁 (components/common/TooltipLayer) — 라이트/다크 팔레트를 따른다 */\r\n.of-tooltip {\r\n  position: fixed;\r\n  z-index: 20000;\r\n  transform: translateX(-50%);\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  font-size: 0.75rem;\r\n  line-height: 1rem;\r\n  white-space: pre-wrap;\r\n  pointer-events: none;\r\n  background: #1f2937;\r\n  color: #f9fafb;\r\n  border: 1px solid #374151;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);\r\n}\r\n.dark .of-tooltip {\r\n  background: #3c3c3c;\r\n  color: #e5e5e5;\r\n  border-color: #555;\r\n}\r\n\r\n/* ── 메모 노드 (포스트잇) */\r\n.memo-node { background: #fef9c3; border-color: #fde047; color: #713f12; }\r\n.memo-node--selected { box-shadow: 0 0 0 2px #f59e0b; }\r\n\r\n/* 이미지/PDF 내보내기 중 — 그림자를 끈다 (CanvasToolbar 가 그리는 동안만 붙인다).\r\n   html-to-image 는 계산된 스타일을 복사하므로 그 순간 클래스로 꺼 두면 그림에 그림자가 남지 않는다. */\r\n.of-exporting .react-flow__node,\r\n.of-exporting .react-flow__node *,\r\n.of-exporting .react-flow__edge * { box-shadow: none !important; filter: none !important; text-shadow: none !important; }\r\n/* 그림에는 편집 장치(노드 위 아이콘·+ 안내)와 선택·마우스 올림 테두리를 넣지 않는다 — 그리는 순간 마우스가 노드 위에 있으면 찍혔다 */\r\n.of-exporting .node-tools,\r\n.of-exporting .node-stub,\r\n.of-exporting .react-flow__nodesselection-rect,\r\n.of-exporting .react-flow__selection { display: none !important; }\r\n.of-exporting .react-flow__node .border-blue-500,\r\n.of-exporting .react-flow__node .border-green-400 { border-color: rgb(var(--c-gray-200)) !important; }\r\n/* 다크 모드에서 배경 없이 뽑을 때: 노드 밖 이름·부제만 어두운 글자로 (canvasImage darkCaptions) */\r\n.of-export-dark-captions .node-caption__name { color: #1f2937 !important; }\r\n.of-export-dark-captions .node-caption__sub { color: #4b5563 !important; }\r\n.memo-node__title { color: #854d0e; }\r\n.memo-node__text { color: #713f12; font-family: inherit; }\r\n.memo-node__text::placeholder { color: #a16207; opacity: 0.6; }\r\n.dark .memo-node { background: #3b3410; border-color: #6b5a12; color: #fde68a; }\r\n.dark .memo-node__title { color: #fcd34d; }\r\n.dark .memo-node__text { color: #fde68a; }\r\n.dark .memo-node__text::placeholder { color: #ca8a04; }\r\n\r\n/* ── 실행 상태 표시 (실행 버튼 → 노드별 실행대기/실행중/실행완료/실패/건너뜀) */\r\n/* 데이터 노드의 처리 건수 — 상태 뱃지와 같은 높이, 반대쪽(오른쪽)에 둔다 */\r\n.rows-badge { position: absolute; top: -9px; right: 8px; z-index: 15; padding: 0 6px; height: 16px; border-radius: 8px;\r\n  font-size: 10px; font-weight: 600; line-height: 16px; color: #fff; white-space: nowrap; background: #6b7280; }\r\n\r\n.run-badge { position: absolute; top: -9px; left: 8px; z-index: 15; display: inline-flex; align-items: center; gap: 4px;\r\n  padding: 0 6px; height: 16px; border-radius: 8px; font-size: 10px; font-weight: 600; line-height: 16px; color: #fff; white-space: nowrap; }\r\n.run-badge--waiting { background: #9ca3af; }\r\n.run-badge--running { background: #2563eb; }\r\n.run-badge--success { background: #16a34a; }\r\n.run-badge--failed  { background: #dc2626; }\r\n.run-badge--skipped { background: #a16207; }\r\n.run-badge__spin { width: 8px; height: 8px; border: 2px solid rgba(255,255,255,.5); border-top-color: #fff; border-radius: 50%; animation: run-spin .8s linear infinite; }\r\n.run-badge__dur { font-weight: 400; padding-left: 4px; border-left: 1px solid rgba(255,255,255,.45); }\r\n@keyframes run-spin { to { transform: rotate(360deg); } }\r\n.run-waiting { opacity: .75; }\r\n.run-running { border-color: #2563eb !important; box-shadow: 0 0 0 3px rgba(37,99,235,.25) !important; }\r\n.run-success { border-color: #16a34a !important; }\r\n.run-failed  { border-color: #dc2626 !important; box-shadow: 0 0 0 3px rgba(220,38,38,.2) !important; }\r\n.run-skipped { opacity: .55; border-style: dashed !important; }\r\n\r\n/* ── 탐색기 미저장 변경 표시 */\r\n.wf-dirty-dot { color: #f59e0b; font-size: 9px; margin-left: 4px; line-height: 1; }\r\n\r\n.run-badge { cursor: pointer; }\r\n\r\n/* ── 노드 호버 스텁: 좌/우 핸들에서 짧은 선 + '+' (클릭 → 그 쪽에 노드 추가) */\r\n.node-stub { position: absolute; top: 50%; transform: translateY(-50%); display: flex; align-items: center; z-index: 12; cursor: pointer;\r\n  /* 바로 사라지지 않게 — 노드를 떠나도 잠깐(0.45초) 남아 있다가 흐려진다. 노드에서 '+' 로 가는 길에 연결 핸들이 있어\r\n     예전에는 그 위를 지나는 순간 사라져 누르기 어려웠다. 보이는 동안은 눌린다(visibility 가 늦게 꺼진다) */\r\n  opacity: 0; visibility: hidden; transition: opacity .15s ease .45s, visibility 0s linear .6s;\r\n  /* 위아래로 마우스가 조금 벗어나도 '+' 위에 있는 것으로 — 선(2px)만 따라가기는 어렵다 */\r\n  padding: 10px 0; }\r\n.node-stub--left { right: 100%; flex-direction: row-reverse; }\r\n.node-stub--right { left: 100%; }\r\n/* 예외 흐름의 '+' — 예외 핸들(85% 높이)에서 30° 아래로 뻗는다. 선만 기울이고 '+' 는 되돌려 똑바로 세운다 */\r\n.node-stub--error { left: 100%; top: 85%; transform: translate(-7px, -50%) rotate(30deg); transform-origin: left center; }\r\n.node-stub--error .node-stub__line { border-top-color: #dc2626; }\r\n.node-stub--error .node-stub__plus { border-color: #dc2626; color: #dc2626; transform: rotate(-30deg); }\r\n.node-stub--error .node-stub__plus:hover { background: #dc2626; color: #fff; }\r\n.node-stub__line { width: 22px; height: 0; border-top: 2px solid #007acc; }\r\n.node-stub__plus { position: relative; width: 20px; height: 20px; border-radius: 50%; border: 2px solid #007acc; background: rgb(var(--c-surface)); color: #007acc; display: inline-block; box-sizing: border-box;\r\n  font-size: 0; }   /* '+' 글자는 글꼴 기준선 때문에 원 가운데에 오지 않는다 — 글자는 숨기고 막대 두 개로 정중앙에 그린다 */\r\n.node-stub__plus::before, .node-stub__plus::after { content: ''; position: absolute; left: 50%; top: 50%; background: currentColor; transform: translate(-50%, -50%); border-radius: 1px; }\r\n.node-stub__plus::before { width: 10px; height: 2px; }\r\n.node-stub__plus::after { width: 2px; height: 10px; }\r\n.node-stub__plus:hover { background: #007acc; color: #fff; }\r\n/* 분기 전용 '+' — 뜻이 '이 갈래에 후행을 연다' 라서 일반 '+'(다음 노드 하나 추가)와 모양·색을 달리한다.\r\n   주황 네모 + 갈라지는 선(위·아래 두 갈래). 색만 바꾸면 무슨 차이인지 알 수 없다. */\r\n.node-stub--branch .node-stub__plus { border-radius: 4px; border-color: #d97706; color: #d97706; }\r\n.node-stub--branch .node-stub__plus:hover { background: #d97706; color: #fff; }\r\n.node-stub__fork { position: relative; width: 22px; height: 18px; }\r\n.node-stub__fork::before, .node-stub__fork::after {\r\n  content: ''; position: absolute; left: 0; width: 22px; height: 8px; border-color: #d97706; border-style: solid;\r\n}\r\n.node-stub__fork::before { top: 1px; border-width: 2px 0 0 2px; border-top-left-radius: 6px; }\r\n.node-stub__fork::after { bottom: 1px; border-width: 0 0 2px 2px; border-bottom-left-radius: 6px; }\r\n\r\n/* 마우스를 올렸을 때, 그리고 **선택한 노드**(하나만 고른 때 — 여럿이면 .of-multiselect 가 감춘다)는 '+' 를 보인다 */\r\n.react-flow__node:hover .node-stub,\r\n.react-flow__node.selected .node-stub { opacity: 1; visibility: visible; transition: opacity .1s ease 0s, visibility 0s linear 0s; }\r\n.react-flow__node.dragging .node-stub, .react-flow__node.selected.dragging .node-stub { opacity: 0; visibility: hidden; transition: none; }\r\n/* 마우스를 올린 노드는 연결선 위로 올린다.\r\n   연결선 층(.react-flow__edges, z-index 5)이 노드 층(.react-flow__nodes, z-index 3)보다 위라서,\r\n   노드에 붙은 '+' 가 선에 가려 눌리지 않았다 — 분기의 '+' 는 나가는 선과 같은 자리라 아예 누를 수 없었다.\r\n   노드 하나만 올려서는 소용이 없다(층이 순서를 정한다). 그래서 **층째** 잠깐 올린다.\r\n   (:has 안에 :has 를 넣으면 규칙 자체가 버려진다 — 브라우저가 조용히 무시한다.) */\r\n/* 그룹(서브플로·반복그룹)에 올렸을 때는 올리지 않는다 — 그룹 상자의 배경이 안쪽 연결선을 덮는다 */\r\n/* 그룹 안 노드(.of-in-group, WorkflowCanvas)도 올리지 않는다 — 층째 올리면 그 노드를 담은 그룹 상자의 배경도 올라가 안쪽 선을 덮는다.\r\n   대신 그 노드에 마우스가 있는 동안 연결선이 클릭을 가로채지 않게 해 '+' 를 누를 수 있게 한다 */\r\n.react-flow__nodes:has(.react-flow__node:not(.react-flow__node-group):not(.react-flow__node-subflow):not(.react-flow__node-repeatGroup):not(.of-in-group):hover) { z-index: 6; }\r\n.react-flow:has(.react-flow__node.of-in-group:hover) .react-flow__edges .react-flow__edge { pointer-events: none; }\r\n.react-flow__node:has(.node-stub):hover { z-index: 1000 !important; }\r\n/* 마우스 아래에 노드가 있는 동안(WorkflowCanvas 가 .of-node-under 를 붙인다) 연결선은 클릭을 가로채지 않는다 —\r\n   선 여러 개에 덮인 노드도 고르고 끌 수 있게. 선에 붙은 '+'(연결선 사이에 넣기)도 그 자리에서는 비켜 준다 */\r\n.of-node-under .react-flow__edges .react-flow__edge,\r\n.of-node-under .react-flow__edgelabel-renderer * { pointer-events: none !important; }\r\n/* 연결 핸들 위에서는 '+'(노드 자동 추가) 안내를 감춘다 — 손으로 잇는 것과 자동 추가는 한 번에 하나만 뜻이 있다.\r\n   커서가 십자(+)로 바뀌어 연결을 시작하는 자리인데 그 옆에 다른 '+' 가 떠 있으면 무엇이 눌리는지 알 수 없다. */\r\n.react-flow__node:has(.react-flow__handle:hover) .node-stub { opacity: 0; visibility: hidden; transition: opacity .15s ease .35s, visibility 0s linear .5s; }\r\n/* (핸들 위를 **지나가기만** 할 때는 지연 덕분에 '+' 가 남아 있다 — 핸들에 머물러 연결하려 할 때만 감춘다) */\r\n\r\n/* 노드 위 아이콘(이력·데이터·삭제)으로 마우스를 옮기는 동안 hover 가 끊기지 않게 — 아이콘 줄 아래를\r\n   노드까지 이어 주는 투명한 다리. 예전에는 아이콘에 닿기 전에 사라져 클릭하기 어려웠다. */\r\n.node-tools::after { content: ''; position: absolute; left: -6px; right: -6px; top: 100%; height: 14px; }\r\n/* 끌고 있는 노드를 놓으면 들어갈 그룹 (canvas 의 dropGroupId) — 그룹 상자에 파란 점선 테두리 */\r\n.react-flow__node.of-drop-target > div { outline: 3px dashed #3b82f6; outline-offset: 3px; border-radius: 8px; }\r\n/* 범위로 여럿을 고른 동안: 노드마다의 아이콘(이력·삭제)과 + 를 감춘다 — 선택 도구 막대(canvas/SelectionToolbar)가 대신한다 */\r\n.of-multiselect .node-tools,\r\n.of-multiselect .node-stub { display: none !important; }\r\n\r\n/* ── 품질검사 위반 경로 핸들(아래) */\r\n.react-flow__handle.reject-handle { background: #dc2626 !important; border-color: #fff !important; }\r\n\r\n/* ── 탐색기 트리 펼침/접힘 애니메이션\r\n   높이를 모르는 콘텐츠를 부드럽게 여닫기 위해 grid-template-rows 0fr↔1fr 을 전이시킨다.\r\n   (max-height 트릭은 값 추정이 필요하고, 조건부 언마운트는 접힘이 애니메이션되지 않는다) */\r\n.tree-collapse { display: grid; grid-template-rows: 0fr; transition: grid-template-rows .22s ease; }\r\n.tree-collapse.open { grid-template-rows: 1fr; }\r\n.tree-collapse > div { overflow: hidden; min-height: 0; }\r\n.tree-chevron { display: inline-flex; transition: transform .2s ease; }\r\n.tree-chevron.open { transform: rotate(90deg); }\r\n/* 트리 항목 배경/글자색도 살짝 부드럽게 */\r\n.workflow-explorer-item { transition: background-color .15s ease, color .15s ease; }\r\n\r\n/* 그룹 접기/펼치기 — 그 순간에만 이동·크기 변화를 부드럽게.\r\n   평소에도 켜 두면 노드를 끌 때 손가락보다 늦게 따라와 답답하다. */\r\n.of-collapse-anim .react-flow__node {\r\n  transition: transform .28s cubic-bezier(.22,.61,.36,1), width .28s cubic-bezier(.22,.61,.36,1), height .28s cubic-bezier(.22,.61,.36,1);\r\n}\r\n.of-collapse-anim .react-flow__edge path {\r\n  transition: d .28s cubic-bezier(.22,.61,.36,1);\r\n}\r\n\r\n/* ── 실행 노드 도형: 사각형 + 좌우 세로줄 (순서도의 '미리 정의된 처리').\r\n   SQL실행·외부명령어·워크플로 실행은 **다른 곳에 정의된 일을 불러 쓰는** 노드라 이 모양이 뜻에 맞는다.\r\n   데이터(둥근 사각형)·처리(알약)와 한눈에 구분되어야 그림이 읽힌다(현장 2026-09-22). */\r\n.node-shape-exec { position: relative; }\r\n.node-shape-exec::before,\r\n.node-shape-exec::after {\r\n  content: ''; position: absolute; top: 0; bottom: 0; width: 1px;\r\n  background: currentColor; opacity: .28; pointer-events: none;\r\n}\r\n.node-shape-exec::before { left: 7px; }\r\n.node-shape-exec::after { right: 7px; }\r\n\r\n/* ── 실행 노드의 '미리보기' 창: 캔버스와 **같은 노드 컴포넌트**로 그리되 읽기 전용으로 보인다.\r\n   노드에 달린 편집 장치(추가 +, 이력·데이터·삭제 아이콘)와 실행 뱃지를 감춘다 —\r\n   컴포넌트가 같아서 그대로 두면 지금 열려 있는 워크플로의 실행 상태가 섞여 보인다(노드 id 가 겹칠 수 있다). */\r\n.of-preview .node-stub,\r\n.of-preview .node-tools,\r\n.of-preview .run-badge,\r\n.of-preview .rows-badge { display: none !important; }\r\n/* 엣지의 + 버튼처럼 '편집용 장치' 로 이미 표시해 둔 것들 — 그림으로 내보낼 때와 같은 기준으로 뺀다 */\r\n.of-preview [data-export-skip] { display: none !important; }\r\n.of-preview .react-flow__handle { pointer-events: none; }\r\n.of-preview .react-flow__node { cursor: default; }\r\n\r\n/* ── 노드 속성을 캔버스 **아래**에 둘 때: 섹션을 폭에 맞춰 여러 칸으로 흘린다 (PropertyDock).\r\n   속성 폼은 세로로 쌓이게 만들어져 있어, 넓고 낮은 영역에 그대로 두면 한 줄로 길게 스크롤되고 옆이 빈다.\r\n   CSS 다단은 폭이 400px 면 한 칸, 1400px 면 서너 칸이 되므로 패널마다 따로 손대지 않아도 된다.\r\n   · 패널 맨 위(제목·노드 유형)는 모든 칸에 걸친다\r\n   · 섹션 하나가 두 칸으로 쪼개지지 않게 한다 — 다만 기본 속성 폼(<form>)은 통째로 한 칸에 몰리지 않게\r\n     폼 안의 항목 단위로 나눈다 */\r\n.prop-dock--bottom .prop-scroll > div { height: auto; overflow: visible; column-width: 22rem; column-gap: 1.75rem; column-rule: 1px solid rgb(229 231 235); }\r\n.prop-dock--bottom .prop-scroll > div > :first-child { column-span: all; }\r\n.prop-dock--bottom .prop-scroll > div > :not(form) { break-inside: avoid; }\r\n.prop-dock--bottom .prop-scroll form .form-group,\r\n.prop-dock--bottom .prop-scroll form .field-object > fieldset > * { break-inside: avoid; }\r\n.dark .prop-dock--bottom .prop-scroll > div { column-rule-color: #3a3a3a; }\r\n\r\n/* ── 가리키는 손가락 (components/common/PointerOverlay) — 도움말·Quick Start·AI 에이전트가 화면의 한 곳을 가리킨다.\r\n   클릭을 가로채지 않는다(pointer-events: none). 위치는 컴포넌트가 transform 으로 옮긴다 */\r\n.of-pointer-layer { position: fixed; inset: 0; pointer-events: none; z-index: 10000; }\r\n.of-pointer-hand, .of-pointer-ring, .of-pointer-bubble { position: absolute; left: 0; top: 0; opacity: 0; will-change: transform; }\r\n.of-pointer-hand { transition: transform 90ms linear, opacity 200ms ease; }\r\n/* 날아가기 — 천천히 출발해 부드럽게 내려앉는다. 시간은 요청마다(--of-fly, 기본 550ms) */\r\n.of-pointer-hand.fly, .of-pointer-bubble.fly { transition: transform var(--of-fly, 550ms) cubic-bezier(.45,.05,.25,1), opacity 200ms ease; }\r\n.of-pointer-hand.on, .of-pointer-bubble.on, .of-pointer-ring.on { opacity: 1; }\r\n.of-pointer-hand-inner { position: relative; color: #fbbf24;\r\n  filter: drop-shadow(0 0 1px #1f2937) drop-shadow(0 0 1px #1f2937) drop-shadow(0 4px 6px rgba(0,0,0,.35)); }\r\n.of-pointer-hand-inner.bob { animation: of-pointer-bob 1.1s ease-in-out infinite; }\r\n.of-pointer-hand-inner.tap { animation: of-pointer-tap 420ms ease-in-out; }\r\n.of-pointer-ripple { position: absolute; left: 13.6px; top: 0; width: 0; height: 0; border-radius: 9999px;\r\n  border: 2px solid #f59e0b; transform: translate(-50%, -50%); animation: of-pointer-ripple 420ms ease-out forwards; }\r\n.of-pointer-ring { border: 3px solid #f59e0b; border-radius: 10px; transition: transform 90ms linear, width 90ms linear, height 90ms linear, opacity 200ms ease;\r\n  box-shadow: 0 0 0 0 rgba(245,158,11,.55); }\r\n.of-pointer-ring.on { animation: of-pointer-glow 1.4s ease-out infinite; }\r\n.of-pointer-bubble { max-width: 240px; padding: 4px 8px; border-radius: 6px; font-size: 12px; line-height: 1.35;\r\n  background: #111827; color: #fff; box-shadow: 0 4px 12px rgba(0,0,0,.25); transition: transform 90ms linear, opacity 200ms ease; }\r\n.dark .of-pointer-bubble { background: #f9fafb; color: #111827; }\r\n@keyframes of-pointer-bob { 0%, 100% { transform: translate(0, 0); } 50% { transform: translate(2px, 6px); } }\r\n@keyframes of-pointer-tap { 0% { transform: scale(1); } 45% { transform: translate(0, 5px) scale(.86); } 100% { transform: scale(1); } }\r\n@keyframes of-pointer-ripple { from { width: 0; height: 0; opacity: 1; } to { width: 44px; height: 44px; opacity: 0; } }\r\n@keyframes of-pointer-glow { 0% { box-shadow: 0 0 0 0 rgba(245,158,11,.55); } 100% { box-shadow: 0 0 0 12px rgba(245,158,11,0); } }\r\n@media (prefers-reduced-motion: reduce) {\r\n  .of-pointer-hand.fly { transition: opacity 200ms ease; }\r\n  .of-pointer-hand-inner.bob, .of-pointer-ring.on { animation: none; }\r\n}\r\n\r\n/* ── 사용 보류 노드 유형 (nodeCatalog.ON_HOLD_NODE_TYPES) — 툴박스 항목에 붙는 리본.\r\n   막지 않는다: 이미 그 노드를 쓰는 워크플로·샘플이 있고 그대로 돌아야 한다. 새로 쓰지 말라는 표시다 */\r\n.of-onhold { opacity: .62; }\r\n.of-onhold:hover { opacity: .85; }\r\n.of-onhold-ribbon { position: absolute; right: -16px; top: 9px; width: 52px; transform: rotate(45deg);\r\n  background: #f59e0b; color: #fff; font-size: 8px; line-height: 12px; text-align: center;\r\n  letter-spacing: -.06em; box-shadow: 0 1px 2px rgba(0,0,0,.25); pointer-events: none; }\r\n/* 이름이 리본 아래로 들어가지 않게 자리를 비운다 */\r\n.of-onhold > span:last-of-type { padding-right: 18px; }\r\n.dark .of-onhold-ribbon { background: #b45309; }\r\n\r\n/* ── 데이터처리의 예외 흐름 핸들 (utils/errorFlow) — 정상(성공) 핸들 조금 아래, 빨강.\r\n   노드 높이가 56px 이라 가운데(50%)의 정상 핸들 아래 74% 지점에 둔다 */\r\n/* 자리·크기는 인라인(utils/errorFlow.ERROR_HANDLE_STYLE)에서 정한다 — CSS 로 옮기면 React Flow 가 잰 자리와\r\n   어긋나 선이 핸들 중앙에서 시작하지 않는다. 여기서는 색만 */\r\n.react-flow__handle.error-handle { background: #fca5a5 !important; border: none !important; }\r\n.react-flow__handle.error-handle:hover,\r\n.react-flow__handle.error-handle.connectingfrom,\r\n.react-flow__handle.error-handle.connectingto { background: #f87171 !important; }\r\n\r\n/* 그룹(서브플로·반복그룹) 크기 조절 손잡이 — 작은 파란 네모 대신 모서리를 감싸는 ㄱ자 꺾쇠.\r\n   잡는 자리가 모서리라는 것과 끌면 크기가 바뀐다는 것이 바로 보인다(현장 2026-10-01). 커서는 React Flow 가 대각선 화살표로 준다 */\r\n.react-flow__resize-control.handle.of-resize-corner {\r\n  /* 테두리와 겹치면 같은 파란색이라 묻힌다 — 바깥으로 조금 띄워 사진 자르기 표시처럼 보이게 */\r\n  width: 20px; height: 20px; background: transparent; border: 0 solid #3772FF; border-radius: 2px;\r\n  transition: width .1s, height .1s, border-color .1s;\r\n}\r\n.react-flow__resize-control.handle.of-resize-corner:hover { width: 26px; height: 26px; border-color: #1d4ed8; }\r\n.dark .react-flow__resize-control.handle.of-resize-corner:hover { border-color: #93c5fd; }\r\n.react-flow__resize-control.handle.of-resize-corner.top.left { border-top-width: 4px; border-left-width: 4px; transform: translate(-8px, -8px); }\r\n.react-flow__resize-control.handle.of-resize-corner.top.right { border-top-width: 4px; border-right-width: 4px; transform: translate(calc(-100% + 8px), -8px); }\r\n.react-flow__resize-control.handle.of-resize-corner.bottom.left { border-bottom-width: 4px; border-left-width: 4px; transform: translate(-8px, calc(-100% + 8px)); }\r\n.react-flow__resize-control.handle.of-resize-corner.bottom.right { border-bottom-width: 4px; border-right-width: 4px; transform: translate(calc(-100% + 8px), calc(-100% + 8px)); }\r\n\r\n/* 실행 중단 노드 — 흐리게 + 왼쪽 아래 주황 ⊠ (BaseNode, 테라스트림 Designer 의 실행 중단 표시와 같은 자리·색) */\r\n.of-suspended { opacity: .55; border-style: dashed !important; }\r\n.of-suspended-badge {\r\n  position: absolute; left: -10px; bottom: -8px; z-index: 21; width: 18px; height: 18px; line-height: 16px; text-align: center;\r\n  font-size: 14px; color: #fff; background: #f59e0b; border: 1px solid #d97706; border-radius: 3px; cursor: pointer; opacity: 1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
